import React__default, { forwardRef, createElement, Fragment, Component, Children, cloneElement, createRef } from 'react';
import cx from 'classnames';
import randomstring from 'randomstring';
import ProgressiveImage from 'react-progressive-image';
import { window as window$1 } from 'browser-monads';
import 'react-dates/initialize';
import { SingleDatePicker, DateRangePicker as DateRangePicker$1 } from 'react-dates';
import { HORIZONTAL_ORIENTATION, ANCHOR_LEFT, START_DATE, END_DATE, NAV_POSITION_TOP } from 'react-dates/constants';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  } // Binding "this" is important for shallow renderer support.


  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
} // React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.


componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  } // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.


  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;

  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }

  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }

  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }

  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  } // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.


  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  } // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.


  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}

var _stackClear = stackClear;
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** Detect free variable `global` from Node.js. */


var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;
/** Built-in value references. */

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);

  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;
/** Used for built-in method references. */

var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);

  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;
/* Built-in method references that are verified to be native. */

var Map = _getNative(_root, 'Map');

var _Map = Map;
/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);

  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof _ListCache) {
    var pairs = data.__data__;

    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new _MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach;

var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');

    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty = defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray_1 = isArray;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && _freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
});
/* Node.js helper references. */


var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys;
/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
  return value === proto;
}

var _isPrototype = isPrototype;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn;
/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }

  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn$1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
});
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */


function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter;
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray() {
  return [];
}

var stubArray_1 = stubArray;
/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush;
/** Built-in value references. */

var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
  var result = [];

  while (object) {
    _arrayPush(result, _getSymbols(object));

    object = _getPrototype(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;
/* Built-in method references that are verified to be native. */

var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;
/* Built-in method references that are verified to be native. */

var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;
/* Built-in method references that are verified to be native. */

var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;
/* Built-in method references that are verified to be native. */

var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;
/** `Object#toString` result references. */

var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


var getTag = _baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1 || _Map && getTag(new _Map()) != mapTag$1 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$1 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;

        case mapCtorString:
          return mapTag$1;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$1;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var _getTag = getTag;
/** Used for built-in method references. */

var objectProto$c = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray;
/** Built-in value references. */

var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;
/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;
/** `Object#toString` result references. */

var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;
/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject_1(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject;
/** `Object#toString` result references. */

var mapTag$3 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;
/* Node.js helper references. */

var nodeIsMap = _nodeUtil && _nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;
var isMap_1 = isMap;
/** `Object#toString` result references. */

var setTag$3 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;
/* Node.js helper references. */

var nodeIsSet = _nodeUtil && _nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;
var isSet_1 = isSet;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] = cloneableTags[numberTag$2] = cloneableTags[objectTag$2] = cloneableTags[regexpTag$2] = cloneableTags[setTag$4] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject_1(value)) {
    return value;
  }

  var isArr = isArray_1(value);

  if (isArr) {
    result = _initCloneArray(value);

    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }

    if (tag == objectTag$2 || tag == argsTag$2 || isFunc && !object) {
      result = isFlat || isFunc ? {} : _initCloneObject(value);

      if (!isDeep) {
        return isFlat ? _copySymbolsIn(value, _baseAssignIn(result, value)) : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = _initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new _Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? _getAllKeysIn : _getAllKeys : isFlat ? keysIn : keys_1;
  var props = isArr ? undefined : keysFunc(value);

  _arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });

  return result;
}

var _baseClone = baseClone;
/** `Object#toString` result references. */

var symbolTag$2 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2;
}

var isSymbol_1 = isSymbol;
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }

  var type = typeof value;

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = _MapCache;
var memoize_1 = memoize;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;
/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = _memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
      result.push('');
    }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

var _stringToPath = stringToPath;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }

  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _toKey = toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

var _baseSlice = baseSlice;
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */

function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */

function baseUnset(object, path) {
  path = _castPath(path, object);
  object = _parent(object, path);
  return object == null || delete object[_toKey(last_1(path))];
}

var _baseUnset = baseUnset;
/** `Object#toString` result references. */

var objectTag$3 = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$d.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto = _getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */

function customOmitClone(value) {
  return isPlainObject_1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone;
/** Built-in value references. */

var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */

function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */

function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;
  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];

    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }

  return result;
}

var _baseFlatten = baseFlatten;
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */

function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

var _apply = apply;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant;
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity(value) {
  return value;
}

var identity_1 = identity;
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !_defineProperty ? identity_1 : function (func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString;
/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */

function flatRest(func) {
  return _setToString(_overRest(func, undefined, flatten_1), func + '');
}

var _flatRest = flatRest;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */

var omit = _flatRest(function (object, paths) {
  var result = {};

  if (object == null) {
    return result;
  }

  var isDeep = false;
  paths = _arrayMap(paths, function (path) {
    path = _castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });

  _copyObject(object, _getAllKeysIn(object), result);

  if (isDeep) {
    result = _baseClone(result, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$1, _customOmitClone);
  }

  var length = paths.length;

  while (length--) {
    _baseUnset(result, paths[length]);
  }

  return result;
});

var omit_1 = omit; //     

var getClassPrefix = function getClassPrefix(classSuffix) {
  var classPrefix = 'kudi-dip';
  return classSuffix ? "".concat(classPrefix, "-").concat(classSuffix) : classPrefix;
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-btn__1uh06 {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 0.07rem solid;\n  font-weight: 500;\n  cursor: pointer; }\n  .module_kudi-dip-btn__1uh06 > * {\n    box-sizing: inherit; }\n  .module_kudi-dip-btn__1uh06:focus, .module_kudi-dip-btn__1uh06:visited, .module_kudi-dip-btn__1uh06:active, .module_kudi-dip-btn__1uh06:link {\n    outline: 0; }\n  .module_kudi-dip-btn__1uh06 > span > svg {\n    height: 100%;\n    margin: 0 auto;\n    fill: currentColor; }\n    .module_kudi-dip-btn__1uh06 > span > svg path,\n    .module_kudi-dip-btn__1uh06 > span > svg circle {\n      fill: currentColor; }\n  .module_kudi-dip-btn-primary__3tr2N, .module_kudi-dip-btn-secondary__1TZo9 {\n    min-height: 45px; }\n    .module_kudi-dip-btn-primary-disabled__3sLwI, .module_kudi-dip-btn-secondary-disabled__NBsC2 {\n      cursor: not-allowed; }\n  .module_kudi-dip-btn-primary__3tr2N, .module_kudi-dip-btn-secondary__1TZo9 {\n    padding: 0.36em 0.36em 0.36em 1.07em;\n    min-width: 10.71em;\n    border-radius: 50px; }\n    .module_kudi-dip-btn-primary__3tr2N > span, .module_kudi-dip-btn-secondary__1TZo9 > span {\n      display: block; }\n      .module_kudi-dip-btn-primary__3tr2N > span:nth-of-type(1), .module_kudi-dip-btn-secondary__1TZo9 > span:nth-of-type(1) {\n        line-height: 1.21em;\n        letter-spacing: 0.03em; }\n      .module_kudi-dip-btn-primary__3tr2N > span:nth-of-type(2), .module_kudi-dip-btn-secondary__1TZo9 > span:nth-of-type(2) {\n        width: 2.14em;\n        height: 2.14em;\n        padding: 0.5em 0;\n        border-radius: 50%;\n        margin-left: 1.43em; }\n  .module_kudi-dip-btn-primary__3tr2N, .module_kudi-dip-btn-fab__t5DH4 {\n    background: #00E59E;\n    border-color: #00E59E;\n    color: #18379A; }\n  .module_kudi-dip-btn-primary__3tr2N:hover {\n    background: #71F2B1;\n    border-color: #71F2B1; }\n    .module_kudi-dip-btn-primary__3tr2N:hover > span:nth-of-type(2) {\n      background: #99FCD6; }\n  .module_kudi-dip-btn-primary-disabled__3sLwI {\n    background: #efefef;\n    color: #9a9a9a;\n    border-color: #efefef; }\n    .module_kudi-dip-btn-primary-disabled__3sLwI:hover {\n      background: #EDEDED;\n      border-color: #EDEDED; }\n      .module_kudi-dip-btn-primary-disabled__3sLwI:hover > span:nth-of-type(2) {\n        background: #F8F8F8; }\n  .module_kudi-dip-btn-secondary__1TZo9, .module_kudi-dip-btn-fab-outlined__31Ujq {\n    background: #fff;\n    border-color: #18379A;\n    color: #18379A; }\n  .module_kudi-dip-btn-secondary__1TZo9 {\n    font-weight: normal; }\n    .module_kudi-dip-btn-secondary__1TZo9:hover > span:nth-of-type(2) {\n      background: #E3E9FD; }\n    .module_kudi-dip-btn-secondary-disabled__NBsC2 {\n      color: #9a9a9a;\n      border-color: #cccccc; }\n      .module_kudi-dip-btn-secondary-disabled__NBsC2:hover > span:nth-of-type(2) {\n        background: #E4E4E4; }\n  .module_kudi-dip-btn-flat__2ZBqu {\n    border: 0;\n    justify-content: flex-start;\n    color: #18379A; }\n    .module_kudi-dip-btn-flat__2ZBqu > span:nth-of-type(1) {\n      height: 1.07em; }\n    .module_kudi-dip-btn-flat__2ZBqu > span:nth-of-type(2) {\n      margin-left: 0.75em;\n      line-height: 1.21em;\n      letter-spacing: 0.03em; }\n    .module_kudi-dip-btn-flat-disabled__3GpXD {\n      color: #9a9a9a; }\n  .module_kudi-dip-btn-fab__t5DH4 {\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    min-height: 45px;\n    min-width: 45px; }\n    .module_kudi-dip-btn-fab__t5DH4 > span {\n      width: 33.75px;\n      height: 33.75px;\n      padding: 4px;\n      border-radius: 50%; }\n    .module_kudi-dip-btn-fab__t5DH4:hover > span {\n      background: #99FCD6; }\n    .module_kudi-dip-btn-fab-outlined__31Ujq:hover > span {\n      background: #E3E9FD; }\n  .module_kudi-dip-btn-dropdown__3alVx, .module_kudi-dip-btn-grouped__2UEv7 {\n    padding: 0.5em 0.71em;\n    border-color: #D2DDEB;\n    color: #748CAD;\n    font-weight: normal;\n    background: #F0F4F9;\n    display: inline-flex; }\n    .module_kudi-dip-btn-dropdown-active__1BlSR, .module_kudi-dip-btn-grouped-active__19yIH {\n      font-weight: 500; }\n    .module_kudi-dip-btn-dropdown-active__1BlSR, .module_kudi-dip-btn-dropdown-open__9HNzD, .module_kudi-dip-btn-dropdown__3alVx:hover, .module_kudi-dip-btn-grouped-active__19yIH, .module_kudi-dip-btn-grouped-open__2RRod, .module_kudi-dip-btn-grouped__2UEv7:hover {\n      color: #0F8CFF;\n      background: #fff; }\n  .module_kudi-dip-btn-dropdown__3alVx {\n    font-size: 1rem;\n    border-radius: 3px;\n    min-width: 9.57em;\n    justify-content: space-between;\n    -webkit-appearance: button; }\n    .module_kudi-dip-btn-dropdown__3alVx > span:nth-of-type(2) {\n      width: 0.71em;\n      margin-left: 0.71em; }\n    .module_kudi-dip-btn-dropdown-options__1-mXv {\n      position: absolute;\n      display: flex;\n      top: 118%;\n      left: 0;\n      flex-direction: column;\n      width: 100%;\n      border: 1px solid #D2DDEB;\n      box-shadow: 0px 10px 15px rgba(171, 191, 216, 0.2);\n      border-radius: 3px;\n      background: #fff;\n      z-index: 999999; }\n    .module_kudi-dip-btn-dropdown-option__1nwvK {\n      padding: 1.07em;\n      color: #748CAD; }\n      .module_kudi-dip-btn-dropdown-option__1nwvK:not(:last-child) {\n        border-bottom: 1px solid #F2F2F2; }\n      .module_kudi-dip-btn-dropdown-option-selected__23GHs, .module_kudi-dip-btn-dropdown-option__1nwvK:hover {\n        background: #F0F4F9; }\n  .module_kudi-dip-btn-grouped__2UEv7 {\n    border-radius: 0;\n    font-size: 1rem; }\n    .module_kudi-dip-btn-grouped__2UEv7:not(:last-child) {\n      border-right: 0; }\n    .module_kudi-dip-btn-grouped__2UEv7:first-child {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px; }\n    .module_kudi-dip-btn-grouped__2UEv7:last-child {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px; }\n\n.module_kudi-dip-btn-grp__ahgxq {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  width: max-content;\n  display: flex; }\n  .module_kudi-dip-btn-grp__ahgxq > * {\n    box-sizing: inherit; }\n";
var styles = {
  "kudi-dip-btn": "module_kudi-dip-btn__1uh06",
  "kudi-dip-btn-primary": "module_kudi-dip-btn-primary__3tr2N",
  "kudi-dip-btn-secondary": "module_kudi-dip-btn-secondary__1TZo9",
  "kudi-dip-btn-primary-disabled": "module_kudi-dip-btn-primary-disabled__3sLwI",
  "kudi-dip-btn-secondary-disabled": "module_kudi-dip-btn-secondary-disabled__NBsC2",
  "kudi-dip-btn-fab": "module_kudi-dip-btn-fab__t5DH4",
  "kudi-dip-btn-fab-outlined": "module_kudi-dip-btn-fab-outlined__31Ujq",
  "kudi-dip-btn-flat": "module_kudi-dip-btn-flat__2ZBqu",
  "kudi-dip-btn-flat-disabled": "module_kudi-dip-btn-flat-disabled__3GpXD",
  "kudi-dip-btn-dropdown": "module_kudi-dip-btn-dropdown__3alVx",
  "kudi-dip-btn-grouped": "module_kudi-dip-btn-grouped__2UEv7",
  "kudi-dip-btn-dropdown-active": "module_kudi-dip-btn-dropdown-active__1BlSR",
  "kudi-dip-btn-grouped-active": "module_kudi-dip-btn-grouped-active__19yIH",
  "kudi-dip-btn-dropdown-open": "module_kudi-dip-btn-dropdown-open__9HNzD",
  "kudi-dip-btn-grouped-open": "module_kudi-dip-btn-grouped-open__2RRod",
  "kudi-dip-btn-dropdown-options": "module_kudi-dip-btn-dropdown-options__1-mXv",
  "kudi-dip-btn-dropdown-option": "module_kudi-dip-btn-dropdown-option__1nwvK",
  "kudi-dip-btn-dropdown-option-selected": "module_kudi-dip-btn-dropdown-option-selected__23GHs",
  "kudi-dip-btn-grp": "module_kudi-dip-btn-grp__ahgxq"
};
styleInject(css);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _ref = /*#__PURE__*/React__default.createElement("path", {
  d: "M.254 14.742A.9.9 0 00.878 15a.9.9 0 00.625-.258l6.636-6.634a.887.887 0 000-1.249L1.505.223a.885.885 0 00-1.25 1.25l6.008 6.01-6.01 6.01a.895.895 0 000 1.249z",
  fill: "#2443A7"
});

var SvgCaretRight = function SvgCaretRight(props) {
  return React__default.createElement("svg", _extends({
    viewBox: "0 0 9 15",
    fill: "none"
  }, props), _ref);
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var _ref$1 = /*#__PURE__*/React__default.createElement("path", {
  d: "M.172.17A.6.6 0 000 .585a.6.6 0 00.172.416l4.423 4.424a.591.591 0 00.832 0l4.424-4.423a.59.59 0 00-.833-.832L5.011 4.175 1.005.17a.597.597 0 00-.833 0z",
  fill: "#748CAD"
});

var SvgCaretDown = function SvgCaretDown(props) {
  return React__default.createElement("svg", _extends$1({
    viewBox: "0 0 10 6",
    fill: "none"
  }, props), _ref$1);
};

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

var _ref$2 = /*#__PURE__*/React__default.createElement("g", {
  transform: "translate(80 50)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a"
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-1.575s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-1.575s"
})));

var _ref2 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(45 -50.355 121.569)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.875
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-1.35s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-1.35s"
})));

var _ref3 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(90 -15 65)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.75
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-1.125s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-1.125s"
})));

var _ref4 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(135 -.355 41.569)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.625
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.9s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.9s"
})));

var _ref5 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(180 10 25)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.5
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.675s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.675s"
})));

var _ref6 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(-135 20.355 8.431)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.375
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.45s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.45s"
})));

var _ref7 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(-90 35 -15)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.25
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.225s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.225s"
})));

var _ref8 = /*#__PURE__*/React__default.createElement("g", {
  transform: "rotate(-45 70.355 -71.569)"
}, React__default.createElement("circle", {
  r: 10,
  fill: "#18379a",
  fillOpacity: 0.125
}, React__default.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  values: "1.1 1.1;1 1",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite"
}), React__default.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1.8s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "0s"
})));

var SvgSpin = function SvgSpin(props) {
  return React__default.createElement("svg", _extends$2({
    className: "spin_svg__lds-spin",
    width: 15,
    height: 15,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "0% 0%"
    }
  }, props), _ref$2, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));

    _this._renderIcon = function () {
      var _this$props = _this.props,
          icon = _this$props.icon,
          loading = _this$props.loading,
          dropdown = _this$props.dropdown;
      if (dropdown) return createElement(SvgCaretDown, null);
      if (!loading) return icon;
      if (loading) return createElement(SvgSpin, null);
      return null;
    };

    _this._setDropdownValue = function (value) {
      return _this.setState({
        dropdownValue: value
      });
    };

    _this._renderBtnContent = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          variant = _this$props2.variant,
          icon = _this$props2.icon,
          value = _this$props2.value,
          options = _this$props2.options;
      var dropdownValue = _this.state.dropdownValue;
      var selectedOptionIndex = options.findIndex(function (item) {
        return item.value === (value || dropdownValue);
      });
      var btnText = createElement("span", null, selectedOptionIndex >= 0 ? options[selectedOptionIndex].text : children);
      var btnIcon = createElement("span", null, _this._renderIcon());
      if (variant === 'flat') return createElement(Fragment, null, icon && btnIcon, btnText);
      if (variant === 'fab') return btnIcon;
      return createElement(Fragment, null, btnText, icon && btnIcon);
    };

    _this._handleShowOptions = function () {
      return _this.setState(function (_ref) {
        var showOptions = _ref.showOptions;
        return {
          showOptions: !showOptions
        };
      });
    };

    _this._renderOptions = function () {
      var _this$props3 = _this.props,
          options = _this$props3.options,
          onSelect = _this$props3.onSelect;
      var componentClass = getClassPrefix('btn-dropdown');
      var dropdownValue = _this.state.dropdownValue;
      return createElement("span", {
        className: styles["".concat(componentClass, "-options")]
      }, options.length > 0 && options.map(function (_ref2, index) {
        var value = _ref2.value,
            text = _ref2.text;
        return createElement("span", {
          className: cx(styles["".concat(componentClass, "-option")], _defineProperty$1({}, "".concat(styles["".concat(componentClass, "-option-selected")]), dropdownValue === value)),
          key: index,
          onClick: function onClick() {
            onSelect(value);
            return _this._setDropdownValue(value);
          }
        }, text);
      }));
    };

    _this.state = {
      showOptions: false,
      dropdownValue: ''
    };
    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _cx2;

      var componentClass = getClassPrefix('btn');

      var _this$props4 = this.props,
          variant = _this$props4.variant,
          disabled = _this$props4.disabled,
          outlined = _this$props4.outlined,
          active = _this$props4.active,
          btnClassName = _this$props4.className,
          dropdown = _this$props4.dropdown,
          rest = _objectWithoutProperties(_this$props4, ["variant", "disabled", "outlined", "active", "className", "dropdown"]);

      var showOptions = this.state.showOptions;
      var className = cx(styles["".concat(componentClass)], btnClassName, (_cx2 = {}, _defineProperty$1(_cx2, "".concat(styles["".concat(componentClass, "-").concat(variant)]), variant && (!dropdown || variant === 'grouped')), _defineProperty$1(_cx2, "".concat(styles["".concat(componentClass, "-").concat(variant, "-disabled")]), disabled), _defineProperty$1(_cx2, "".concat(styles["".concat(componentClass, "-").concat(variant, "-outlined")]), outlined), _defineProperty$1(_cx2, "".concat(styles["".concat(componentClass, "-").concat(variant, "-active")]), active), _defineProperty$1(_cx2, "".concat(styles["".concat(componentClass, "-dropdown")]), dropdown), _defineProperty$1(_cx2, "".concat(styles["".concat(componentClass, "-dropdown-open")]), dropdown && showOptions), _cx2));
      var nativeButtonProps = omit_1(rest, ['loading', 'icon', 'children', 'className', 'options', 'innerRef']);
      return !dropdown ? createElement("button", _extends$3({
        ref: rest.innerRef
      }, nativeButtonProps, {
        className: className
      }), this._renderBtnContent()) : createElement("div", _extends$3({
        ref: rest.innerRef
      }, nativeButtonProps, {
        onClick: this._handleShowOptions,
        className: className
      }), this._renderBtnContent(), showOptions && this._renderOptions());
    }
  }]);

  return Button;
}(Component);

Button.defaultProps = {
  variant: 'primary',
  disabled: false,
  loading: false,
  icon: createElement(SvgCaretRight, null),
  outlined: false,
  options: []
};
polyfill(Button); //$FlowFixMe

var Button$1 = forwardRef(function (props, ref) {
  return createElement(Button, _extends$3({
    innerRef: ref
  }, props));
});

function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

var ButtonGroup = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ButtonGroup, _React$Component);

  function ButtonGroup() {
    _classCallCheck$1(this, ButtonGroup);

    return _possibleConstructorReturn$1(this, _getPrototypeOf$1(ButtonGroup).apply(this, arguments));
  }

  _createClass$1(ButtonGroup, [{
    key: "render",
    value: function render() {
      var componentClass = getClassPrefix('btn-grp');

      var _this$props = this.props,
          children = _this$props.children,
          grpClassName = _this$props.className,
          rest = _objectWithoutProperties$1(_this$props, ["children", "className"]);

      var className = cx(styles["".concat(componentClass)], grpClassName);
      var nativeDivProps = omit_1(rest, ['children', 'className']);
      var groupChildren = Children.map(children, function (child) {
        return child.props.dropdown ? cloneElement(child, {
          variant: 'grouped'
        }) : cloneElement(child, {
          icon: null,
          variant: 'grouped'
        });
      });
      return createElement("div", _extends$4({}, nativeDivProps, {
        className: className
      }), groupChildren);
    }
  }]);

  return ButtonGroup;
}(Component);

polyfill(ButtonGroup);
var css$1 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-input__3mE7O {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  background: initial; }\n  .module_kudi-dip-input__3mE7O > * {\n    box-sizing: inherit; }\n  .module_kudi-dip-input__3mE7O label {\n    transition: all 0.2s;\n    font-size: 1em;\n    touch-action: manipulation;\n    text-transform: capitalize;\n    position: absolute;\n    top: 1.29em;\n    left: 1.07em;\n    letter-spacing: 0.03em;\n    line-height: 1.29em;\n    color: #223856;\n    display: inline-flex;\n    align-items: center; }\n    .module_kudi-dip-input__3mE7O label svg {\n      margin-left: 0.36em;\n      height: 0.36em; }\n  .module_kudi-dip-input__3mE7O input {\n    font-size: 1em;\n    cursor: text;\n    transition: all 0.2s;\n    touch-action: manipulation;\n    border: 0.07rem solid #D2DDEB;\n    border-radius: 3px;\n    width: 100%;\n    position: relative;\n    padding: 1.285em 1.07em;\n    line-height: 1.28em;\n    color: #223856; }\n    .module_kudi-dip-input__3mE7O input:focus, .module_kudi-dip-input__3mE7O input:visited, .module_kudi-dip-input__3mE7O input:active, .module_kudi-dip-input__3mE7O input:link {\n      outline: 0; }\n    .module_kudi-dip-input__3mE7O input:focus {\n      border-color: #748CAD;\n      padding-top: 1.857em;\n      padding-bottom: 0.714em; }\n    .module_kudi-dip-input__3mE7O input::-webkit-input-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-input__3mE7O input::-moz-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-input__3mE7O input:-ms-input-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-input__3mE7O input:-moz-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-input__3mE7O input:placeholder-shown + label {\n      cursor: text;\n      white-space: nowrap; }\n    .module_kudi-dip-input__3mE7O input:focus::-webkit-input-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-input__3mE7O input:focus::-moz-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-input__3mE7O input:focus:-ms-input-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-input__3mE7O input:focus:-moz-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-input__3mE7O input:not(:placeholder-shown) + label, .module_kudi-dip-input__3mE7O input:focus + label {\n      cursor: pointer;\n      font-size: 0.714em;\n      color: #748CAD;\n      left: 1.6em;\n      line-height: 1.3em; }\n  .module_kudi-dip-input-filled__3Lh7F > input {\n    padding-top: 1.857em;\n    padding-bottom: 0.714em; }\n  .module_kudi-dip-input-error__2AzO7 > input {\n    border-color: #ff5b5b; }\n    .module_kudi-dip-input-error__2AzO7 > input:not(:placeholder-shown) + label, .module_kudi-dip-input-error__2AzO7 > input:focus + label {\n      color: #ff5b5b; }\n  .module_kudi-dip-input-error__2AzO7 > small {\n    display: inline-block;\n    font-size: 0.86em;\n    line-height: 1.33em;\n    color: #ff5b5b;\n    margin-top: 0.42em; }\n  .module_kudi-dip-input-success__qhlem > input {\n    border-color: #24cb35; }\n  .module_kudi-dip-input-disabled__2tSDU {\n    pointer-events: none;\n    cursor: not-allowed; }\n    .module_kudi-dip-input-disabled__2tSDU > input {\n      border-color: #D2DDEB;\n      background-color: #F0F4F9;\n      pointer-events: none;\n      cursor: inherit; }\n    .module_kudi-dip-input-disabled__2tSDU > label {\n      color: #748CAD;\n      cursor: inherit; }\n  .module_kudi-dip-input__3mE7O > svg {\n    position: absolute;\n    right: 1.07em;\n    top: 1.285em;\n    width: 1.43em;\n    height: 1.43em; }\n";
var styles$1 = {
  "kudi-dip-input": "module_kudi-dip-input__3mE7O",
  "kudi-dip-input-filled": "module_kudi-dip-input-filled__3Lh7F",
  "kudi-dip-input-error": "module_kudi-dip-input-error__2AzO7",
  "kudi-dip-input-success": "module_kudi-dip-input-success__qhlem",
  "kudi-dip-input-disabled": "module_kudi-dip-input-disabled__2tSDU"
};
styleInject(css$1);

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var _ref$3 = /*#__PURE__*/React__default.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FF5B5B"
});

var _ref2$1 = /*#__PURE__*/React__default.createElement("path", {
  d: "M10.53 15.7a.195.195 0 01-.06.151.19.19 0 01-.15.062H8.746a.214.214 0 01-.21-.213v-1.575a.21.21 0 01.21-.208h1.574a.21.21 0 01.21.208V15.7zm.536-10.486L11 6.036l-.287 3.594-.18 2.273a.214.214 0 01-.032.104.193.193 0 01-.155.106h-1.6c-.124 0-.204-.098-.213-.212l-.066-.822-.286-3.593L8 5.212C7.991 5.098 8.103 5 8.212 5h2.638c.108.002.223.1.215.214z",
  fill: "#fff"
});

var SvgInputError = function SvgInputError(props) {
  return React__default.createElement("svg", _extends$5({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref$3, _ref2$1);
};

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

var _ref$4 = /*#__PURE__*/React__default.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#24CB35",
  stroke: "#24CB35"
});

var _ref2$2 = /*#__PURE__*/React__default.createElement("path", {
  d: "M8.615 12.677l-2.769-2.77a.595.595 0 00-.861 0 .595.595 0 000 .862l3.63 3.631 6.954-6.954a.595.595 0 000-.861.595.595 0 00-.861 0l-6.093 6.092z",
  fill: "#fff",
  stroke: "#fff"
});

var SvgInputSuccess = function SvgInputSuccess(props) {
  return React__default.createElement("svg", _extends$6({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref$4, _ref2$2);
};

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

var _ref$5 = /*#__PURE__*/React__default.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  fill: "#FF5B5B"
});

var _ref2$3 = /*#__PURE__*/React__default.createElement("path", {
  d: "M2.15 1v.978l-.59-.34-.26-.15-.3.521.26.15.587.341-.588.337-.259.15.3.522.26-.15.59-.34V4h.6v-.978l.587.337.26.15.3-.522-.26-.15L3.05 2.5l.588-.34.259-.15-.3-.522-.26.15-.587.337V1h-.6z",
  fill: "#fff"
});

var SvgAsterisk = function SvgAsterisk(props) {
  return React__default.createElement("svg", _extends$7({
    viewBox: "0 0 5 5",
    fill: "none"
  }, props), _ref$5, _ref2$3);
};

function _typeof$2(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$2(self);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits$2(Input, _React$Component);

  function Input(props) {
    var _this;

    _classCallCheck$2(this, Input);

    _this = _possibleConstructorReturn$2(this, _getPrototypeOf$2(Input).call(this, props));

    _this._renderIcon = function () {
      var _this$props = _this.props,
          status = _this$props.status,
          icon = _this$props.icon;
      if (icon && !status) return icon;
      if (status === 'error') return createElement(SvgInputError, null);
      if (status === 'success') return createElement(SvgInputSuccess, null);
      return null;
    };

    _this._handleOnChange = function (e) {
      return _this.setState({
        value: e.target.value
      });
    };

    _this._getValue = function () {
      var valueFromProp = _this.props.value;
      var value = _this.state.value;
      if ("".concat(valueFromProp).length) return valueFromProp;
      return value;
    };

    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass$2(Input, [{
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var componentClass = getClassPrefix('input');
      var uniqueId = randomstring.generate(6);

      var _this$props2 = this.props,
          status = _this$props2.status,
          inputClassName = _this$props2.className,
          name = _this$props2.name,
          label = _this$props2.label,
          disabled = _this$props2.disabled,
          _onChange = _this$props2.onChange,
          error = _this$props2.error,
          rest = _objectWithoutProperties$2(_this$props2, ["status", "className", "name", "label", "disabled", "onChange", "error"]);

      uniqueId = "".concat(uniqueId).concat(name);
      var className = cx(styles$1["".concat(componentClass)], inputClassName, (_cx = {}, _defineProperty$2(_cx, "".concat(styles$1["".concat(componentClass, "-").concat(status)]), status), _defineProperty$2(_cx, "".concat(styles$1["".concat(componentClass, "-disabled")]), disabled), _defineProperty$2(_cx, "".concat(styles$1["".concat(componentClass, "-filled")]), this._getValue()), _cx));
      var nativeButtonProps = omit_1(rest, ['innerRef']);
      return createElement("div", {
        className: className
      }, createElement("input", _extends$8({
        value: this._getValue(),
        onChange: function onChange(e) {
          _this2._handleOnChange(e);

          return _onChange(e);
        },
        disabled: disabled,
        name: name,
        id: uniqueId,
        ref: rest.innerRef
      }, nativeButtonProps)), createElement("label", {
        htmlFor: uniqueId
      }, createElement("span", null, label), rest.required && createElement(SvgAsterisk, null)), this._renderIcon(), error && createElement("small", null, " ", error, " "));
    }
  }]);

  return Input;
}(Component);

Input.defaultProps = {
  type: 'text',
  status: '',
  disabled: false,
  required: false,
  label: '',
  placeholder: 'Label',
  error: '',
  name: '',
  value: '',
  //$FlowFixMe
  onChange: function onChange() {
    return null;
  }
};
polyfill(Input); //$FlowFixMe

var input = forwardRef(function (props, ref) {
  return createElement(Input, _extends$8({
    innerRef: ref
  }, props));
});
var css$2 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-select__2LqOb {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff; }\n  .module_kudi-dip-select__2LqOb > * {\n    box-sizing: inherit; }\n  .module_kudi-dip-select__2LqOb label {\n    transition: all 0.2s;\n    font-size: 1em;\n    touch-action: manipulation;\n    text-transform: capitalize;\n    position: absolute;\n    top: 1.29em;\n    left: 1.07em;\n    letter-spacing: 0.03em;\n    line-height: 1.29em;\n    color: #223856;\n    display: inline-flex;\n    align-items: center; }\n    .module_kudi-dip-select__2LqOb label svg {\n      margin-left: 0.36em;\n      height: 0.36em; }\n  .module_kudi-dip-select__2LqOb input {\n    font-size: 1em;\n    cursor: text;\n    transition: all 0.2s;\n    touch-action: manipulation;\n    border: 0.07rem solid #D2DDEB;\n    border-radius: 3px;\n    width: 100%;\n    position: relative;\n    padding: 1.285em 1.07em;\n    line-height: 1.28em;\n    color: #223856; }\n    .module_kudi-dip-select__2LqOb input:focus, .module_kudi-dip-select__2LqOb input:visited, .module_kudi-dip-select__2LqOb input:active, .module_kudi-dip-select__2LqOb input:link {\n      outline: 0; }\n    .module_kudi-dip-select__2LqOb input:focus {\n      border-color: #748CAD;\n      padding-top: 1.857em;\n      padding-bottom: 0.714em; }\n    .module_kudi-dip-select__2LqOb input::-webkit-input-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-select__2LqOb input::-moz-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-select__2LqOb input:-ms-input-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-select__2LqOb input:-moz-placeholder {\n      opacity: 0;\n      transition: inherit;\n      color: #b9c5d6; }\n    .module_kudi-dip-select__2LqOb input:placeholder-shown + label {\n      cursor: text;\n      white-space: nowrap; }\n    .module_kudi-dip-select__2LqOb input:focus::-webkit-input-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-select__2LqOb input:focus::-moz-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-select__2LqOb input:focus:-ms-input-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-select__2LqOb input:focus:-moz-placeholder {\n      opacity: 1; }\n    .module_kudi-dip-select__2LqOb input:not(:placeholder-shown) + label, .module_kudi-dip-select__2LqOb input:focus + label {\n      cursor: pointer;\n      font-size: 0.714em;\n      color: #748CAD;\n      left: 1.6em;\n      line-height: 1.3em; }\n  .module_kudi-dip-select-filled__DiTLo > input {\n    padding-top: 1.857em;\n    padding-bottom: 0.714em; }\n  .module_kudi-dip-select-error__2BI7s > input {\n    border-color: #ff5b5b; }\n    .module_kudi-dip-select-error__2BI7s > input:not(:placeholder-shown) + label, .module_kudi-dip-select-error__2BI7s > input:focus + label {\n      color: #ff5b5b; }\n  .module_kudi-dip-select-error__2BI7s > small {\n    display: inline-block;\n    font-size: 0.86em;\n    line-height: 1.33em;\n    color: #ff5b5b;\n    margin-top: 0.42em; }\n  .module_kudi-dip-select-success__2xOP_ > input {\n    border-color: #24cb35; }\n  .module_kudi-dip-select-disabled__34te9 {\n    pointer-events: none;\n    cursor: not-allowed; }\n    .module_kudi-dip-select-disabled__34te9 > input {\n      border-color: #D2DDEB;\n      background-color: #F0F4F9;\n      pointer-events: none;\n      cursor: inherit; }\n    .module_kudi-dip-select-disabled__34te9 > label {\n      color: #748CAD;\n      cursor: inherit; }\n  .module_kudi-dip-select__2LqOb > svg {\n    position: absolute;\n    top: 1.285em;\n    width: 1.43em;\n    height: 1.43em; }\n  .module_kudi-dip-select-caret__r4aMF {\n    right: 1.07em;\n    transition: all 0.3s;\n    cursor: pointer; }\n    .module_kudi-dip-select-caret-up__ywCD_ {\n      transform: rotate(180deg); }\n  .module_kudi-dip-select-status-icon__DS4eq {\n    right: 3.57em; }\n  .module_kudi-dip-select-options__37Md4 {\n    position: absolute;\n    display: flex;\n    top: 110%;\n    left: 0;\n    flex-direction: column;\n    width: 100%;\n    border: 1px solid #D2DDEB;\n    box-shadow: 0px 10px 15px rgba(171, 191, 216, 0.2);\n    border-radius: 3px;\n    background: #fff;\n    z-index: 999999;\n    display: none; }\n    .module_kudi-dip-select-options-show__2464g {\n      display: block; }\n  .module_kudi-dip-select-option__4mKi8 {\n    padding: 1.07em;\n    color: #748CAD;\n    cursor: pointer; }\n    .module_kudi-dip-select-option__4mKi8:not(:last-child) {\n      border-bottom: 1px solid #F2F2F2; }\n    .module_kudi-dip-select-option-selected__1Fxzm, .module_kudi-dip-select-option__4mKi8:hover {\n      background: #F0F4F9; }\n";
var styles$2 = {
  "kudi-dip-select": "module_kudi-dip-select__2LqOb",
  "kudi-dip-select-filled": "module_kudi-dip-select-filled__DiTLo",
  "kudi-dip-select-error": "module_kudi-dip-select-error__2BI7s",
  "kudi-dip-select-success": "module_kudi-dip-select-success__2xOP_",
  "kudi-dip-select-disabled": "module_kudi-dip-select-disabled__34te9",
  "kudi-dip-select-caret": "module_kudi-dip-select-caret__r4aMF",
  "kudi-dip-select-caret-up": "module_kudi-dip-select-caret-up__ywCD_",
  "kudi-dip-select-status-icon": "module_kudi-dip-select-status-icon__DS4eq",
  "kudi-dip-select-options": "module_kudi-dip-select-options__37Md4",
  "kudi-dip-select-options-show": "module_kudi-dip-select-options-show__2464g",
  "kudi-dip-select-option": "module_kudi-dip-select-option__4mKi8",
  "kudi-dip-select-option-selected": "module_kudi-dip-select-option-selected__1Fxzm"
};
styleInject(css$2);

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

var _ref$6 = /*#__PURE__*/React__default.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FF5B5B"
});

var _ref2$4 = /*#__PURE__*/React__default.createElement("path", {
  d: "M10.53 15.7a.195.195 0 01-.06.151.19.19 0 01-.15.062H8.746a.214.214 0 01-.21-.213v-1.575a.21.21 0 01.21-.208h1.574a.21.21 0 01.21.208V15.7zm.536-10.486L11 6.036l-.287 3.594-.18 2.273a.214.214 0 01-.032.104.193.193 0 01-.155.106h-1.6c-.124 0-.204-.098-.213-.212l-.066-.822-.286-3.593L8 5.212C7.991 5.098 8.103 5 8.212 5h2.638c.108.002.223.1.215.214z",
  fill: "#fff"
});

var SvgInputError$1 = function SvgInputError(props) {
  return React__default.createElement("svg", _extends$9({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref$6, _ref2$4);
};

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

var _ref$7 = /*#__PURE__*/React__default.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#24CB35",
  stroke: "#24CB35"
});

var _ref2$5 = /*#__PURE__*/React__default.createElement("path", {
  d: "M8.615 12.677l-2.769-2.77a.595.595 0 00-.861 0 .595.595 0 000 .862l3.63 3.631 6.954-6.954a.595.595 0 000-.861.595.595 0 00-.861 0l-6.093 6.092z",
  fill: "#fff",
  stroke: "#fff"
});

var SvgInputSuccess$1 = function SvgInputSuccess(props) {
  return React__default.createElement("svg", _extends$a({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref$7, _ref2$5);
};

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

var _ref$8 = /*#__PURE__*/React__default.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  fill: "#FF5B5B"
});

var _ref2$6 = /*#__PURE__*/React__default.createElement("path", {
  d: "M2.15 1v.978l-.59-.34-.26-.15-.3.521.26.15.587.341-.588.337-.259.15.3.522.26-.15.59-.34V4h.6v-.978l.587.337.26.15.3-.522-.26-.15L3.05 2.5l.588-.34.259-.15-.3-.522-.26.15-.587.337V1h-.6z",
  fill: "#fff"
});

var SvgAsterisk$1 = function SvgAsterisk(props) {
  return React__default.createElement("svg", _extends$b({
    viewBox: "0 0 5 5",
    fill: "none"
  }, props), _ref$8, _ref2$6);
};

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

var _ref$9 = /*#__PURE__*/React__default.createElement("path", {
  d: "M.956.556a.9.9 0 00-.258.624.9.9 0 00.258.625L7.59 8.44a.887.887 0 001.249 0l6.636-6.634a.885.885 0 00-1.25-1.249l-6.01 6.007-6.01-6.01a.895.895 0 00-1.249 0z",
  fill: "#D2DDEB"
});

var SvgCaretDown$1 = function SvgCaretDown(props) {
  return React__default.createElement("svg", _extends$c({
    viewBox: "0 0 16 9",
    fill: "none"
  }, props), _ref$9);
};

function _typeof$3(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$3(obj);
}

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$3(self);
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$3(o);
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$3(o, p);
}

var componentClass = getClassPrefix('select');

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits$3(Select, _React$Component);

  function Select(props) {
    var _this;

    _classCallCheck$3(this, Select);

    _this = _possibleConstructorReturn$3(this, _getPrototypeOf$3(Select).call(this, props));

    _this._renderStatusIcon = function (className) {
      var status = _this.props.status;
      if (status === 'error') return createElement(SvgInputError$1, {
        className: className
      });
      if (status === 'success') return createElement(SvgInputSuccess$1, {
        className: className
      });
      return null;
    };

    _this._handleOnSelect = function (value) {
      return _this.setState({
        value: value
      });
    };

    _this._handleOnChange = function (e) {
      return _this.setState({
        value: e.target.value
      });
    };

    _this._showOptions = function (state) {
      return _this.setState(function (_ref) {
        var showOptions = _ref.showOptions;
        return {
          showOptions: !state ? state : !showOptions
        };
      });
    };

    _this._renderOptions = function (className) {
      var _this$props = _this.props,
          options = _this$props.options,
          onSelect = _this$props.onSelect;
      var _this$state = _this.state,
          value = _this$state.value,
          showOptions = _this$state.showOptions;
      options = _this._filterOptions(options, value);
      return options.length > 0 && createElement("div", {
        className: cx(styles$2["".concat(className, "-options")], _defineProperty$3({}, "".concat(styles$2["".concat(className, "-options-show")]), showOptions))
      }, options.map(function (_ref2, i) {
        var optionValue = _ref2.value,
            text = _ref2.text;
        return createElement("div", {
          className: cx(styles$2["".concat(className, "-option")], _defineProperty$3({}, "".concat(styles$2["".concat(className, "-option-selected")]), value === optionValue)),
          key: "".concat(value, "-").concat(i),
          onClick: function onClick() {
            onSelect(optionValue);

            _this._handleOnSelect(text);

            return _this._showOptions();
          }
        }, text);
      }));
    };

    _this._filterOptions = function (options, value) {
      if (value) {
        var searchTerm = value.toLowerCase().split(' ').filter(function (item) {
          return item !== '';
        });
        var searchResult = searchTerm.reduce(function (acc, term) {
          var result = options.filter(function (_ref3) {
            var text = _ref3.text,
                value = _ref3.value;
            return text.toLowerCase().includes(term) || "".concat(value).toLowerCase().includes(term);
          });
          return acc.concat(result);
        }, []);
        return _toConsumableArray(new Set(searchResult));
      }

      return options;
    };

    _this.state = {
      value: '',
      showOptions: false
    };
    _this.inputRef = createRef();
    return _this;
  }

  _createClass$3(Select, [{
    key: "render",
    value: function render() {
      var _cx3,
          _this2 = this;

      var uniqueId = randomstring.generate(6);

      var _this$props2 = this.props,
          status = _this$props2.status,
          selectClassName = _this$props2.className,
          name = _this$props2.name,
          label = _this$props2.label,
          disabled = _this$props2.disabled,
          valueFromProp = _this$props2.value,
          error = _this$props2.error,
          rest = _objectWithoutProperties$3(_this$props2, ["status", "className", "name", "label", "disabled", "value", "error"]);

      var _this$state2 = this.state,
          value = _this$state2.value,
          showOptions = _this$state2.showOptions;
      uniqueId = "".concat(uniqueId).concat(name);
      var className = cx(styles$2["".concat(componentClass)], selectClassName, (_cx3 = {}, _defineProperty$3(_cx3, "".concat(styles$2["".concat(componentClass, "-").concat(status)]), status), _defineProperty$3(_cx3, "".concat(styles$2["".concat(componentClass, "-disabled")]), disabled), _defineProperty$3(_cx3, "".concat(styles$2["".concat(componentClass, "-filled")]), value || valueFromProp), _cx3));
      var nativeSelectProps = omit_1(rest, ['innerRef']);
      return createElement("div", {
        ref: rest.innerRef,
        className: className
      }, createElement("input", _extends$d({
        value: value || valueFromProp,
        onChange: function onChange(e) {
          if (!showOptions) _this2._showOptions();
          return _this2._handleOnChange(e);
        },
        disabled: disabled,
        id: uniqueId,
        ref: this.inputRef,
        onFocus: this._showOptions
      }, nativeSelectProps)), createElement("label", {
        htmlFor: uniqueId
      }, createElement("span", null, label), rest.required && createElement(SvgAsterisk$1, null)), this._renderStatusIcon("".concat(styles$2["".concat(componentClass, "-status-icon")])), createElement(SvgCaretDown$1, {
        className: cx(styles$2["".concat(componentClass, "-caret")], _defineProperty$3({}, "".concat(styles$2["".concat(componentClass, "-caret-up")]), showOptions)),
        onClick: function onClick() {
          //$FlowFixMe
          return _this2.inputRef.current.focus();
        }
      }), error && createElement("small", null, " ", error, " "), this._renderOptions(componentClass));
    }
  }]);

  return Select;
}(Component);

Select.defaultProps = {
  status: '',
  disabled: false,
  required: false,
  label: '',
  placeholder: 'Label',
  error: '',
  name: '',
  value: '',
  options: [],
  //$FlowFixMe
  onSelect: function onSelect() {
    return null;
  }
};
polyfill(Select); //$FlowFixMe

var select = forwardRef(function (props, ref) {
  return createElement(Select, _extends$d({
    innerRef: ref
  }, props));
});
var css$3 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-upload__1eCoC {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  transition: all 0.2s;\n  touch-action: manipulation;\n  border: 0.07rem solid #D2DDEB;\n  border-radius: 3px; }\n  .module_kudi-dip-upload__1eCoC > * {\n    box-sizing: inherit; }\n  .module_kudi-dip-upload__1eCoC label {\n    transition: all 0.2s;\n    font-size: 1em;\n    touch-action: manipulation;\n    text-transform: capitalize;\n    position: absolute;\n    top: 1.29em;\n    left: 1.07em;\n    letter-spacing: 0.03em;\n    line-height: 1.29em;\n    color: #223856;\n    display: inline-flex;\n    align-items: center; }\n    .module_kudi-dip-upload__1eCoC label svg {\n      margin-left: 0.36em;\n      height: 0.36em; }\n  .module_kudi-dip-upload__1eCoC p {\n    position: absolute;\n    font-size: 1em;\n    color: #223856;\n    left: 1.07em;\n    top: 1.857em;\n    margin: 0;\n    line-height: 1.29em;\n    display: none; }\n  .module_kudi-dip-upload__1eCoC input {\n    font-size: 0.95em;\n    z-index: 99;\n    opacity: 0;\n    width: 100%;\n    position: relative;\n    padding: 1.285em 1.07em; }\n  .module_kudi-dip-upload-filled__1eH6x > p {\n    display: block; }\n  .module_kudi-dip-upload-filled__1eH6x label {\n    cursor: pointer;\n    font-size: 0.714em;\n    color: #748CAD;\n    left: 1.6em;\n    line-height: 1.3em; }\n  .module_kudi-dip-upload-error__o5QJD {\n    border-color: #ff5b5b; }\n    .module_kudi-dip-upload-error__o5QJD label {\n      color: #ff5b5b; }\n    .module_kudi-dip-upload-error__o5QJD > small {\n      display: inline-block;\n      font-size: 0.86em;\n      line-height: 1.33em;\n      color: #ff5b5b;\n      margin-top: 0.42em; }\n  .module_kudi-dip-upload-success__19qP3 {\n    border-color: #24cb35; }\n  .module_kudi-dip-upload-disabled__3OkhV {\n    pointer-events: none;\n    cursor: not-allowed;\n    border-color: #D2DDEB;\n    background-color: #F0F4F9;\n    pointer-events: none; }\n    .module_kudi-dip-upload-disabled__3OkhV > label {\n      color: #748CAD;\n      cursor: inherit; }\n  .module_kudi-dip-upload__1eCoC > svg {\n    position: absolute;\n    top: 1.285em;\n    width: 1.43em;\n    height: 1.43em; }\n  .module_kudi-dip-upload-add__3_3rl {\n    right: 1.07em; }\n  .module_kudi-dip-upload-status-icon__Jj-7J {\n    right: 3.57em; }\n";
var styles$3 = {
  "kudi-dip-upload": "module_kudi-dip-upload__1eCoC",
  "kudi-dip-upload-filled": "module_kudi-dip-upload-filled__1eH6x",
  "kudi-dip-upload-error": "module_kudi-dip-upload-error__o5QJD",
  "kudi-dip-upload-success": "module_kudi-dip-upload-success__19qP3",
  "kudi-dip-upload-disabled": "module_kudi-dip-upload-disabled__3OkhV",
  "kudi-dip-upload-add": "module_kudi-dip-upload-add__3_3rl",
  "kudi-dip-upload-status-icon": "module_kudi-dip-upload-status-icon__Jj-7J"
};
styleInject(css$3);

function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$e.apply(this, arguments);
}

var _ref$a = /*#__PURE__*/React__default.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FF5B5B"
});

var _ref2$7 = /*#__PURE__*/React__default.createElement("path", {
  d: "M10.53 15.7a.195.195 0 01-.06.151.19.19 0 01-.15.062H8.746a.214.214 0 01-.21-.213v-1.575a.21.21 0 01.21-.208h1.574a.21.21 0 01.21.208V15.7zm.536-10.486L11 6.036l-.287 3.594-.18 2.273a.214.214 0 01-.032.104.193.193 0 01-.155.106h-1.6c-.124 0-.204-.098-.213-.212l-.066-.822-.286-3.593L8 5.212C7.991 5.098 8.103 5 8.212 5h2.638c.108.002.223.1.215.214z",
  fill: "#fff"
});

var SvgInputError$2 = function SvgInputError(props) {
  return React__default.createElement("svg", _extends$e({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref$a, _ref2$7);
};

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

var _ref$b = /*#__PURE__*/React__default.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#24CB35",
  stroke: "#24CB35"
});

var _ref2$8 = /*#__PURE__*/React__default.createElement("path", {
  d: "M8.615 12.677l-2.769-2.77a.595.595 0 00-.861 0 .595.595 0 000 .862l3.63 3.631 6.954-6.954a.595.595 0 000-.861.595.595 0 00-.861 0l-6.093 6.092z",
  fill: "#fff",
  stroke: "#fff"
});

var SvgInputSuccess$2 = function SvgInputSuccess(props) {
  return React__default.createElement("svg", _extends$f({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref$b, _ref2$8);
};

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

var _ref$c = /*#__PURE__*/React__default.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  fill: "#FF5B5B"
});

var _ref2$9 = /*#__PURE__*/React__default.createElement("path", {
  d: "M2.15 1v.978l-.59-.34-.26-.15-.3.521.26.15.587.341-.588.337-.259.15.3.522.26-.15.59-.34V4h.6v-.978l.587.337.26.15.3-.522-.26-.15L3.05 2.5l.588-.34.259-.15-.3-.522-.26.15-.587.337V1h-.6z",
  fill: "#fff"
});

var SvgAsterisk$2 = function SvgAsterisk(props) {
  return React__default.createElement("svg", _extends$g({
    viewBox: "0 0 5 5",
    fill: "none"
  }, props), _ref$c, _ref2$9);
};

function _extends$h() {
  _extends$h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$h.apply(this, arguments);
}

var _ref$d = /*#__PURE__*/React__default.createElement("path", {
  d: "M8.5 1a.625.625 0 00-.625.625v6.25h-6.25a.625.625 0 100 1.25h6.25v6.25a.625.625 0 101.25 0v-6.25h6.25a.625.625 0 100-1.25h-6.25v-6.25A.625.625 0 008.5 1z",
  fill: "#748CAD",
  stroke: "#748CAD",
  strokeWidth: 0.6
});

var SvgAdd = function SvgAdd(props) {
  return React__default.createElement("svg", _extends$h({
    viewBox: "0 0 17 17",
    fill: "none"
  }, props), _ref$d);
};

function _typeof$4(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$4 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$4 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$4(obj);
}

function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$i.apply(this, arguments);
}

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$4(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$4(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$4(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$4(self);
}

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$4(o);
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$4(subClass, superClass);
}

function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$4(o, p);
}

var componentClass$1 = getClassPrefix('upload');

var Upload = /*#__PURE__*/function (_React$Component) {
  _inherits$4(Upload, _React$Component);

  function Upload(props) {
    var _this;

    _classCallCheck$4(this, Upload);

    _this = _possibleConstructorReturn$4(this, _getPrototypeOf$4(Upload).call(this, props));

    _this._renderStatusIcon = function (className) {
      var status = _this.props.status;
      if (status === 'error') return createElement(SvgInputError$2, {
        className: className
      });
      if (status === 'success') return createElement(SvgInputSuccess$2, {
        className: className
      });
      return null;
    };

    _this._handleOnChange = function (e) {
      var onChange = _this.props.onChange;

      var file = _this._fileListToArray(e.target.files)[0];

      if (file) {
        _this.setState({
          fileName: file.name
        });

        return onChange(e);
      }

      return null;
    };

    _this._fileListToArray = function (list) {
      var array = [];

      for (var i = 0; i < list.length; i++) {
        array.push(list.item(i));
      }

      return array;
    };

    _this.state = {
      fileName: ''
    };
    _this.inputRef = createRef();
    return _this;
  }

  _createClass$4(Upload, [{
    key: "render",
    value: function render() {
      var _cx;

      var uniqueId = randomstring.generate(6);

      var _this$props = this.props,
          status = _this$props.status,
          uploadClassName = _this$props.className,
          name = _this$props.name,
          label = _this$props.label,
          disabled = _this$props.disabled,
          error = _this$props.error,
          rest = _objectWithoutProperties$4(_this$props, ["status", "className", "name", "label", "disabled", "error"]);

      var fileName = this.state.fileName;
      uniqueId = "".concat(uniqueId).concat(name);
      var className = cx(styles$3["".concat(componentClass$1)], uploadClassName, (_cx = {}, _defineProperty$4(_cx, "".concat(styles$3["".concat(componentClass$1, "-").concat(status)]), status), _defineProperty$4(_cx, "".concat(styles$3["".concat(componentClass$1, "-disabled")]), disabled), _defineProperty$4(_cx, "".concat(styles$3["".concat(componentClass$1, "-filled")]), fileName), _cx));
      var nativeUploadProps = omit_1(rest, ['innerRef', 'onChange']);
      return createElement("div", {
        ref: rest.innerRef,
        className: className
      }, createElement("input", _extends$i({
        type: "file",
        disabled: disabled,
        id: uniqueId,
        ref: this.inputRef
      }, nativeUploadProps, {
        onChange: this._handleOnChange,
        multiple: false
      })), createElement("label", {
        htmlFor: uniqueId
      }, createElement("span", null, label), rest.required && createElement(SvgAsterisk$2, null)), createElement("p", null, fileName), this._renderStatusIcon("".concat(styles$3["".concat(componentClass$1, "-status-icon")])), createElement(SvgAdd, {
        className: styles$3["".concat(componentClass$1, "-add")]
      }), error && createElement("small", null, " ", error, " "));
    }
  }]);

  return Upload;
}(Component);

Upload.defaultProps = {
  status: '',
  disabled: false,
  required: false,
  label: '',
  placeholder: 'Label',
  error: '',
  name: '',
  //$FlowFixMe
  onChange: function onChange() {
    return null;
  }
};
polyfill(Upload); //$FlowFixMe

var upload = forwardRef(function (props, ref) {
  return createElement(Upload, _extends$i({
    innerRef: ref
  }, props));
});
var css$4 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-auth-layout__1nbKd {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  display: block;\n  grid-template-columns: repeat(2, 1fr);\n  height: 100vh;\n  background: #18379A; }\n  .module_kudi-dip-auth-layout__1nbKd > * {\n    box-sizing: inherit; }\n  @media (min-width: 768px) {\n    .module_kudi-dip-auth-layout__1nbKd {\n      display: grid; } }\n  .module_kudi-dip-auth-layout-content__2P_ev, .module_kudi-dip-auth-layout-info__1fL9x {\n    position: relative;\n    height: 100%;\n    width: 100%; }\n  .module_kudi-dip-auth-layout-content__2P_ev {\n    padding-top: 4.29em;\n    overflow: auto; }\n    @media (min-width: 768px) {\n      .module_kudi-dip-auth-layout-content__2P_ev {\n        padding-top: 6.64em; } }\n    .module_kudi-dip-auth-layout-content-header__w8DQe {\n      position: fixed;\n      width: 100%;\n      top: 0;\n      left: 0;\n      background: #18379A;\n      z-index: 999999;\n      display: flex;\n      align-items: center; }\n      @media (min-width: 768px) {\n        .module_kudi-dip-auth-layout-content-header__w8DQe {\n          display: block;\n          padding: 2.14em 5.71em; } }\n      .module_kudi-dip-auth-layout-content-header__w8DQe .module_logo__1AZkS {\n        height: 1.79em; }\n        @media (min-width: 768px) {\n          .module_kudi-dip-auth-layout-content-header__w8DQe .module_logo__1AZkS {\n            height: 2.14em; } }\n      .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1 {\n        font-size: 1em;\n        width: 4.286em;\n        height: 4.286em;\n        padding: 0;\n        margin: 0;\n        background: transparent;\n        outline: 0;\n        border: 0;\n        margin-right: 1.43em; }\n        .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1:focus, .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1:active, .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1:visited, .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1:link, .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1:hover, .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1:focus-within {\n          outline: 0;\n          border: 0; }\n        .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1 > svg {\n          height: 1.29em;\n          fill: #fff;\n          vertical-align: middle; }\n          .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1 > svg path {\n            fill: #fff; }\n        @media (min-width: 768px) {\n          .module_kudi-dip-auth-layout-content-header__w8DQe .module_backBtn__3WDl1 {\n            display: none; } }\n  .module_kudi-dip-auth-layout-noHeader__3jfwb > .module_kudi-dip-auth-layout-content__2P_ev {\n    padding-top: 0; }\n  .module_kudi-dip-auth-layout-info__1fL9x {\n    display: none;\n    overflow: hidden;\n    z-index: 9999999; }\n    @media (min-width: 768px) {\n      .module_kudi-dip-auth-layout-info__1fL9x {\n        display: block; } }\n    .module_kudi-dip-auth-layout-info__1fL9x > img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover; }\n    .module_kudi-dip-auth-layout-info-underlay__3LIXT {\n      background: rgba(0, 0, 0, 0.3);\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0; }\n";
var styles$4 = {
  "kudi-dip-auth-layout": "module_kudi-dip-auth-layout__1nbKd",
  "kudi-dip-auth-layout-content": "module_kudi-dip-auth-layout-content__2P_ev",
  "kudi-dip-auth-layout-info": "module_kudi-dip-auth-layout-info__1fL9x",
  "kudi-dip-auth-layout-content-header": "module_kudi-dip-auth-layout-content-header__w8DQe",
  "logo": "module_logo__1AZkS",
  "backBtn": "module_backBtn__3WDl1",
  "kudi-dip-auth-layout-noHeader": "module_kudi-dip-auth-layout-noHeader__3jfwb",
  "kudi-dip-auth-layout-info-underlay": "module_kudi-dip-auth-layout-info-underlay__3LIXT"
};
styleInject(css$4);

function _extends$j() {
  _extends$j = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$j.apply(this, arguments);
}

var _ref$e = /*#__PURE__*/React__default.createElement("path", {
  d: "M.622 2.104c.373-.375.903-.57 1.43-.57H5.35c-.539.563-1.102 1.103-1.648 1.66C2.468 4.423 1.237 5.657.004 6.888-.004 5.785.004 4.68 0 3.577a2 2 0 01.622-1.473zM11.386 1.536c1.764-.003 3.529 0 5.293-.002-2.26 2.275-4.533 4.536-6.796 6.807C6.587 11.633 3.298 14.933 0 18.223v-5.3c3.796-3.795 7.593-7.59 11.386-11.387zM.002 24.206C7.56 16.65 15.11 9.086 22.67 1.532c1.168.004 2.336.001 3.504.001.498-.001 1 .167 1.372.503.429.369.692.927.686 1.494v23.914c-.001.222.008.446-.023.667a2.042 2.042 0 01-.924 1.359c-.364.235-.806.318-1.233.307-1.167.002-2.335-.003-3.502.003-1.507-1.489-2.998-2.994-4.5-4.49-2.252-2.253-4.508-4.503-6.76-6.757-.306.27-.577.58-.87.865-.669.679-1.344 1.35-2.01 2.031 2.221 2.226 4.432 4.46 6.653 6.686.547.556 1.106 1.1 1.645 1.664-1.86-.004-3.72 0-5.579-.002-1.845-1.873-3.688-3.748-5.532-5.623-.945.972-1.886 1.95-2.834 2.918.488.478.984.947 1.468 1.429.439.423.882.841 1.308 1.277H2.096c-.53.007-1.07-.177-1.452-.55a2.006 2.006 0 01-.642-1.45v-3.572z",
  fill: "#00E59E"
});

var _ref2$a = /*#__PURE__*/React__default.createElement("path", {
  d: "M53.717 1.313h-7.06l-6.689 9.275V1.313h-6.074V29.59h6.074v-9.604l8.496 9.604h7.797L43.005 15.308 53.717 1.313zM68.662 20.56c0 2.669-1.478 3.9-3.447 3.9-1.683 0-3.407-1.067-3.407-3.817V10.424h-5.704v11.45c0 5.253 3.119 8.126 7.592 8.126 1.929 0 3.981-1.19 4.966-3.037v2.627h5.704V10.424h-5.704v10.137zM91.885 19.945c0 2.668-1.97 4.638-4.432 4.638-2.463 0-4.433-1.847-4.433-4.638 0-2.667 1.97-4.555 4.433-4.555 2.462 0 4.432 1.765 4.432 4.555zM97.672 0h-5.664v12.763c-.944-1.682-3.16-2.75-5.622-2.75-2.545 0-4.72.945-6.567 2.791-1.805 1.847-2.708 4.269-2.708 7.264 0 2.914.903 5.336 2.708 7.182 1.847 1.847 4.022 2.75 6.567 2.75 2.462 0 4.678-1.026 5.622-2.79v2.38h5.664V0zM100.444 10.424V29.59h5.664V10.424h-5.664zM103.276 0c-1.97 0-3.57 1.477-3.57 3.324 0 1.847 1.6 3.365 3.57 3.365 1.929 0 3.488-1.518 3.488-3.365 0-1.847-1.559-3.324-3.488-3.324z",
  fill: "#fff"
});

var SvgLogo = function SvgLogo(props) {
  return React__default.createElement("svg", _extends$j({
    viewBox: "0 0 107 30",
    fill: "none"
  }, props), _ref$e, _ref2$a);
};

function _extends$k() {
  _extends$k = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$k.apply(this, arguments);
}

var _ref$f = /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.287 9.514a.968.968 0 00-.287.68c0 .244.096.487.287.682l7.703 7.832c.383.39.957.39 1.34 0a.952.952 0 000-1.362l-7.033-7.151 7.416-7.54a.951.951 0 000-1.363c-.335-.39-.957-.39-1.34 0L1.287 9.514z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
});

var SvgChevronLeft = function SvgChevronLeft(props) {
  return React__default.createElement("svg", _extends$k({
    viewBox: "0 0 12 20",
    fill: "none"
  }, props), _ref$f);
};

function _extends$l() {
  _extends$l = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$l.apply(this, arguments);
}

function _typeof$5(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$5 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$5 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$5(obj);
}

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$5(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$5(self, call) {
  if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$5(self);
}

function _assertThisInitialized$5(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$5(o) {
  _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$5(o);
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$5(subClass, superClass);
}

function _setPrototypeOf$5(o, p) {
  _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$5(o, p);
}

var componentClass$2 = getClassPrefix('auth-layout');

var AuthLayout = /*#__PURE__*/function (_React$Component) {
  _inherits$5(AuthLayout, _React$Component);

  function AuthLayout(props) {
    _classCallCheck$5(this, AuthLayout);

    return _possibleConstructorReturn$5(this, _getPrototypeOf$5(AuthLayout).call(this, props));
  }

  _createClass$5(AuthLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          innerRef = _this$props.innerRef,
          children = _this$props.children,
          infoContent = _this$props.infoContent,
          infoBackground = _this$props.infoBackground,
          infoBackgroundPlaceholder = _this$props.infoBackgroundPlaceholder,
          noHeader = _this$props.noHeader;
      return createElement("div", {
        ref: innerRef,
        className: cx(styles$4["".concat(componentClass$2)], className, _defineProperty$5({}, "".concat(styles$4["".concat(componentClass$2, "-noHeader")]), noHeader))
      }, createElement("div", {
        className: styles$4["".concat(componentClass$2, "-content")]
      }, !noHeader && createElement("header", {
        className: styles$4["".concat(componentClass$2, "-content-header")]
      }, createElement("button", {
        onClick: function onClick() {
          return window$1.history.back();
        },
        className: styles$4.backBtn
      }, createElement(SvgChevronLeft, null)), createElement(SvgLogo, {
        className: styles$4.logo
      })), children), createElement("div", {
        className: styles$4["".concat(componentClass$2, "-info")]
      }, createElement(ProgressiveImage, {
        src: infoBackground,
        placeholder: infoBackgroundPlaceholder
      }, function (src) {
        return createElement("img", {
          className: styles$4.item1,
          src: src,
          alt: "content background"
        });
      }), createElement("div", {
        className: styles$4["".concat(componentClass$2, "-info-underlay")]
      }, infoContent)));
    }
  }]);

  return AuthLayout;
}(Component);

AuthLayout.defaultProps = {
  noHeader: false
};
polyfill(AuthLayout); //$FlowFixMe

var authLayout = forwardRef(function (props, ref) {
  return createElement(AuthLayout, _extends$l({
    innerRef: ref
  }, props));
});
var css$5 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-date-picker__33k3G,\n.module_kudi-dip-date-range-picker__pM9hr {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff; }\n  .module_kudi-dip-date-picker__33k3G > *,\n  .module_kudi-dip-date-range-picker__pM9hr > * {\n    box-sizing: inherit; }\n  .module_kudi-dip-date-picker__33k3G > *,\n  .module_kudi-dip-date-range-picker__pM9hr > * {\n    box-sizing: inherit; }\n\n.module_kudi-dip-date-picker__33k3G .DayPicker {\n  width: 338px !important; }\n  .module_kudi-dip-date-picker__33k3G .DayPicker > div > div {\n    width: 338px !important; }\n  .module_kudi-dip-date-picker__33k3G .DayPicker_transitionContainer {\n    width: 338px !important; }\n\n.module_kudi-dip-date-range-picker__pM9hr .DayPicker {\n  width: 676px !important; }\n  .module_kudi-dip-date-range-picker__pM9hr .DayPicker > div > div {\n    width: 676px !important; }\n  .module_kudi-dip-date-range-picker__pM9hr .DayPicker_transitionContainer {\n    width: 676px !important; }\n\n.DateInput__small {\n  width: max-content; }\n\n.DateInput_input {\n  padding: 0;\n  color: #223856; }\n  .DateInput_input__focused {\n    border-bottom: 2px solid transparent; }\n\n.DateInput > input {\n  width: 100%;\n  outline: 0; }\n\n.DateInput_fang {\n  display: none; }\n\n.SingleDatePickerInput,\n.DateRangePickerInput {\n  background: #FFFFFF;\n  border: 1px solid #D2DDEB;\n  border-radius: 3px;\n  overflow: hidden; }\n  .SingleDatePickerInput_calendarIcon,\n  .DateRangePickerInput_calendarIcon {\n    margin: 0;\n    margin-right: 10px; }\n    .SingleDatePickerInput_calendarIcon > svg,\n    .DateRangePickerInput_calendarIcon > svg {\n      height: 15px; }\n  .SingleDatePickerInput_arrow,\n  .DateRangePickerInput_arrow {\n    margin-right: 12px; }\n\n.DayPicker_transitionContainer {\n  background: #FAFAFA; }\n\n.DayPicker_weekHeaders {\n  display: none; }\n\n.DayPickerNavigation {\n  display: flex;\n  position: absolute;\n  width: 100%;\n  justify-content: space-between;\n  top: 20px; }\n  .DayPickerNavigation_button {\n    height: 15px; }\n    .DayPickerNavigation_button:nth-of-type(1) {\n      position: relative;\n      left: 36px; }\n    .DayPickerNavigation_button:nth-of-type(2) {\n      position: relative;\n      right: 36px; }\n    .DayPickerNavigation_button > svg {\n      height: 100%; }\n\n.CalendarMonth {\n  padding: 0px 22px !important;\n  position: relative;\n  background: #FAFAFA; }\n  .CalendarMonth::before {\n    position: absolute;\n    content: \"\";\n    background: #F2F2F2;\n    height: 1px;\n    width: 100%;\n    top: 55px;\n    left: 0; }\n  .CalendarMonthGrid__horizontal {\n    left: 0; }\n  .CalendarMonth_caption {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 17px;\n    padding-top: 18px;\n    padding-bottom: 39px;\n    color: #223856; }\n    .CalendarMonth_caption > strong {\n      font-weight: inherit; }\n  .CalendarMonth_table tr {\n    display: flex; }\n    .CalendarMonth_table tr:nth-of-type(1) {\n      justify-content: flex-end; }\n    .CalendarMonth_table tr td {\n      margin: 2.5px 4.09px; }\n      .CalendarMonth_table tr td:first-of-type {\n        margin-left: 0; }\n      .CalendarMonth_table tr td:last-of-type {\n        margin-right: 0; }\n\n.CalendarDay {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  border: 0 !important;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 16px;\n  width: 35px !important;\n  height: 35px !important;\n  color: #223856;\n  background: #FAFAFA;\n  outline: 0; }\n  .CalendarDay:hover {\n    background: #eae8e8; }\n  .CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover {\n    background: #0F8CFF;\n    border: 1px double #0F8CFF;\n    color: #fff; }\n  .CalendarDay__selected_span, .CalendarDay__selected_span:active, .CalendarDay__selected_span:hover {\n    background: #0f8cff8a;\n    border: 1px double #0f8cff8a;\n    color: #fff; }\n\n.DayPickerKeyboardShortcuts_show {\n  display: none; }\n";
var styles$5 = {
  "kudi-dip-date-picker": "module_kudi-dip-date-picker__33k3G",
  "kudi-dip-date-range-picker": "module_kudi-dip-date-range-picker__pM9hr"
};
styleInject(css$5);

function _extends$m() {
  _extends$m = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$m.apply(this, arguments);
}

var _ref$g = /*#__PURE__*/React__default.createElement("path", {
  d: "M10.04 14.742a1.13 1.13 0 01-.723.258 1.13 1.13 0 01-.722-.258L.917 8.108a.83.83 0 01-.298-.624.83.83 0 01.298-.625L8.592.223c.195-.15.45-.23.71-.223.261.007.51.1.694.26.184.159.291.373.3.599a.817.817 0 01-.259.613l-6.95 6.012 6.953 6.009a.836.836 0 01.293.624.836.836 0 01-.293.625z",
  fill: "#223856"
});

var SvgChevronLeft$1 = function SvgChevronLeft(props) {
  return React__default.createElement("svg", _extends$m({
    viewBox: "0 0 11 15",
    fill: "none"
  }, props), _ref$g);
};

function _extends$n() {
  _extends$n = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$n.apply(this, arguments);
}

var _ref$h = /*#__PURE__*/React__default.createElement("path", {
  d: "M.96 14.742c.193.164.452.256.723.258.27-.002.53-.094.722-.258l7.679-6.634a.83.83 0 00.297-.624.83.83 0 00-.297-.625L2.408.223c-.195-.15-.45-.23-.71-.223-.261.007-.51.1-.694.26a.832.832 0 00-.3.599.817.817 0 00.259.613l6.95 6.012L.96 13.493a.836.836 0 00-.293.624c0 .234.105.458.293.625z",
  fill: "#223856"
});

var SvgChevronRight = function SvgChevronRight(props) {
  return React__default.createElement("svg", _extends$n({
    viewBox: "0 0 11 15",
    fill: "none"
  }, props), _ref$h);
};

function _extends$o() {
  _extends$o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$o.apply(this, arguments);
}

var _ref$i = /*#__PURE__*/React__default.createElement("path", {
  d: "M13.292.765h-2.636V.51a.514.514 0 00-.52-.51.514.514 0 00-.52.51v.255H4.511V.51a.514.514 0 00-.52-.51.514.514 0 00-.52.51v.255H.743c-.427 0-.743.29-.743.728V14.29c0 .4.297.71.743.71h12.512c.426 0 .742-.31.742-.71V1.493c.037-.4-.278-.728-.705-.728zm-12.234 1h2.45v.256c0 .273.223.51.52.51.279 0 .52-.22.52-.51v-.255h5.105v.255c0 .273.223.51.52.51.278 0 .52-.22.52-.51v-.255h2.339v2.093H1.095V1.766h-.037zm11.955 12.216H1.077V4.86h11.936v9.12zM3.1 7.227h1.54v1.51H3.1v-1.51zm3.175 0h1.54v1.51h-1.54v-1.51zm3.174 0h1.54v1.51H9.45v-1.51zM3.1 10.176h1.54v1.51H3.1v-1.51zm3.175 0h1.54v1.51h-1.54v-1.51z",
  fill: "#748CAD"
});

var SvgCalendar = function SvgCalendar(props) {
  return React__default.createElement("svg", _extends$o({
    viewBox: "0 0 14 15",
    fill: "none"
  }, props), _ref$i);
};

function _typeof$6(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$6 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$6 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$6(obj);
}

function _extends$p() {
  _extends$p = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$p.apply(this, arguments);
}

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$6(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$6(self, call) {
  if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$6(self);
}

function _assertThisInitialized$6(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$6(o) {
  _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$6(o);
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$6(subClass, superClass);
}

function _setPrototypeOf$6(o, p) {
  _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$6(o, p);
}

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits$6(DatePicker, _React$Component);

  function DatePicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$6(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$6(this, (_getPrototypeOf2 = _getPrototypeOf$6(DatePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this._handleInputSize = function () {
      var id = _this.props.id;
      var el = document.getElementById("".concat(id)); //$FlowFixMe

      if (el.value.length > 0) {
        //$FlowFixMe
        el.size = el.value.length;
      }
    };

    return _this;
  }

  _createClass$6(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._handleInputSize();
    }
  }, {
    key: "render",
    value: function render() {
      var componentClass = getClassPrefix('date-picker');
      var _this$props = this.props,
          onDateChange = _this$props.onDateChange,
          onFocusChange = _this$props.onFocusChange,
          datePickerClassName = _this$props.className,
          initialDate = _this$props.initialDate,
          autoFocus = _this$props.autoFocus,
          id = _this$props.id;
      var props = omit_1(this.props, ['autoFocus', 'initialDate', 'onDateChange', 'onFocusChange', 'className', 'id']);
      var className = cx(styles$5["".concat(componentClass)], datePickerClassName);
      return createElement("div", {
        className: className
      }, createElement(SingleDatePicker, _extends$p({}, props, {
        id: id,
        date: initialDate,
        focused: autoFocus,
        onDateChange: onDateChange,
        onFocusChange: onFocusChange
      })));
    }
  }]);

  return DatePicker;
}(Component);

DatePicker.defaultProps = {
  // example props for the demo
  autoFocus: false,
  initialDate: moment(),
  // input related props
  id: 'date_input',
  placeholder: 'Date',
  disabled: false,
  required: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,
  block: false,
  small: true,
  regular: false,
  verticalSpacing: undefined,
  keepFocusOnInput: false,
  readOnly: true,
  customInputIcon: createElement(SvgCalendar, null),
  // calendar presentation and interaction related props
  renderMonthText: null,
  orientation: HORIZONTAL_ORIENTATION,
  anchorDirection: ANCHOR_LEFT,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 1,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  isRTL: false,
  // navigation related props
  navPrev: createElement(SvgChevronLeft$1, null),
  navNext: createElement(SvgChevronRight, null),
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isDayHighlighted: function isDayHighlighted() {},
  // internationalization props
  displayFormat: 'dddd - D MMM, YY',
  monthFormat: 'MMMM YYYY'
};
polyfill(DatePicker);

function _typeof$7(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$7 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$7 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$7(obj);
}

function _extends$q() {
  _extends$q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$q.apply(this, arguments);
}

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$7(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$7(self, call) {
  if (call && (_typeof$7(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$7(self);
}

function _assertThisInitialized$7(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$7(o) {
  _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$7(o);
}

function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$7(subClass, superClass);
}

function _setPrototypeOf$7(o, p) {
  _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$7(o, p);
}

var DateRangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits$7(DateRangePicker, _React$Component);

  function DateRangePicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$7(this, DateRangePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$7(this, (_getPrototypeOf2 = _getPrototypeOf$7(DateRangePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this._handleInputSize = function () {
      var _this$props = _this.props,
          startDateId = _this$props.startDateId,
          endDateId = _this$props.endDateId; //$FlowFixMe

      var startDateInput = document.getElementById("".concat(startDateId)); //$FlowFixMe

      var endDateInput = document.getElementById("".concat(endDateId)); //$FlowFixMe

      if (startDateInput.value.length > 0) {
        //$FlowFixMe
        startDateInput.size = startDateInput.value.length;
      } //$FlowFixMe


      if (endDateInput.value.length > 0) {
        //$FlowFixMe
        endDateInput.size = endDateInput.value.length;
      }
    };

    return _this;
  }

  _createClass$7(DateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._handleInputSize();
    }
  }, {
    key: "render",
    value: function render() {
      var componentClass = getClassPrefix('date-range-picker');
      var _this$props2 = this.props,
          focusedInput = _this$props2.focusedInput,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate,
          onFocusChange = _this$props2.onFocusChange,
          onDatesChange = _this$props2.onDatesChange,
          componentClassName = _this$props2.className;
      var props = omit_1(this.props, ['initialStartDate', 'initialEndDate', 'focusedInput', 'startDate', 'endDate', 'onDatesChange', 'onFocusChange', 'className']);
      var className = cx(styles$5["".concat(componentClass)], componentClassName);
      return createElement("div", {
        className: className
      }, createElement(DateRangePicker$1, _extends$q({}, props, {
        onDatesChange: onDatesChange,
        onFocusChange: onFocusChange,
        focusedInput: focusedInput,
        startDate: startDate,
        endDate: endDate
      })));
    }
  }]);

  return DateRangePicker;
}(Component);

DateRangePicker.defaultProps = {
  // example props for the demo
  startDate: moment(),
  endDate: moment().add(1, 'months'),
  // input related props
  startDateId: START_DATE,
  startDatePlaceholderText: 'Start Date',
  endDateId: END_DATE,
  endDatePlaceholderText: 'End Date',
  disabled: false,
  required: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  customInputIcon: createElement(SvgCalendar, null),
  customArrowIcon: null,
  customCloseIcon: null,
  block: false,
  small: true,
  regular: false,
  readOnly: true,
  focusedInput: null,
  // calendar presentation and interaction related props
  renderMonthText: null,
  orientation: HORIZONTAL_ORIENTATION,
  anchorDirection: ANCHOR_LEFT,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  isRTL: false,
  // navigation related props
  navPosition: NAV_POSITION_TOP,
  navPrev: createElement(SvgChevronLeft$1, null),
  navNext: createElement(SvgChevronRight, null),
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  minimumNights: 1,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  // internationalization
  displayFormat: 'DD MMM, YY',
  monthFormat: 'MMMM YYYY'
};
polyfill(DateRangePicker);
var css$6 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-table__1xUPc {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  background: white;\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100%; }\n  .module_kudi-dip-table__1xUPc > * {\n    box-sizing: inherit; }\n  .module_kudi-dip-table__1xUPc table {\n    width: inherit;\n    border-spacing: 0; }\n  .module_kudi-dip-table-body__33M5b > tr:nth-of-type(odd) {\n    background: #F7F9FC;\n    border-radius: 3px; }\n  .module_kudi-dip-table__1xUPc td,\n  .module_kudi-dip-table__1xUPc th {\n    text-align: left;\n    font-weight: normal;\n    padding: 20px 0;\n    letter-spacing: 0.03em; }\n    .module_kudi-dip-table__1xUPc td:first-child,\n    .module_kudi-dip-table__1xUPc th:first-child {\n      padding-left: 15px;\n      text-align: left; }\n    .module_kudi-dip-table__1xUPc td:last-child,\n    .module_kudi-dip-table__1xUPc th:last-child {\n      padding-right: 15px; }\n  .module_kudi-dip-table__1xUPc th {\n    text-transform: uppercase;\n    font-size: 11px;\n    line-height: 13px;\n    color: #223856; }\n  .module_kudi-dip-table__1xUPc td {\n    font-size: 13px;\n    line-height: 16px;\n    color: #748CAD; }\n";
var styles$6 = {
  "kudi-dip-table": "module_kudi-dip-table__1xUPc",
  "kudi-dip-table-body": "module_kudi-dip-table-body__33M5b"
};
styleInject(css$6);

function _extends$r() {
  _extends$r = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$r.apply(this, arguments);
}

var TableHead = function TableHead(props) {
  var column = props.column;
  var componentClass = getClassPrefix('table-header');
  return createElement("thead", {
    className: cx(styles$6["".concat(componentClass)])
  }, createElement("tr", null, column.map(function (_ref) {
    var key = _ref.key,
        render = _ref.render;
    return createElement("th", {
      key: key
    }, render);
  })));
};

TableHead.defaultProps = {
  column: [] //$FlowFixMe

};
var TableHead$1 = forwardRef(function (props, ref) {
  return createElement(TableHead, _extends$r({
    innerRef: ref
  }, props));
});

function _extends$s() {
  _extends$s = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$s.apply(this, arguments);
}

var TableBody = function TableBody(props) {
  var data = props.data,
      columnKeys = props.columnKeys;
  var componentClass = getClassPrefix('table-body');
  return createElement("tbody", {
    className: cx(styles$6["".concat(componentClass)])
  }, data.map(function (row, index) {
    return createElement("tr", {
      key: index
    }, columnKeys.map(function (key) {
      return createElement("td", {
        key: key
      }, row[key]);
    }));
  }));
};

TableBody.defaultProps = {
  data: [],
  columnKeys: [] //$FlowFixMe

};
var TableBody$1 = forwardRef(function (props, ref) {
  return createElement(TableBody, _extends$s({
    innerRef: ref
  }, props));
});

function _extends$t() {
  _extends$t = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$t.apply(this, arguments);
}

function _typeof$8(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$8 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$8 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$8(obj);
}

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$8(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$8(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$8(self, call) {
  if (call && (_typeof$8(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$8(self);
}

function _assertThisInitialized$8(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$8(o) {
  _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$8(o);
}

function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$8(subClass, superClass);
}

function _setPrototypeOf$8(o, p) {
  _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$8(o, p);
}

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits$8(Table, _React$Component);

  function Table(props) {
    _classCallCheck$8(this, Table);

    return _possibleConstructorReturn$8(this, _getPrototypeOf$8(Table).call(this, props));
  }

  _createClass$8(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          column = _this$props.column,
          loading = _this$props.loading,
          innerRef = _this$props.innerRef,
          componentClassName = _this$props.className;
      var componentClass = getClassPrefix('table');
      var className = cx(styles$6["".concat(componentClass)], componentClassName);
      var columnKeys = column.map(function (item) {
        return item.key;
      });
      return createElement("div", {
        ref: innerRef,
        className: className
      }, createElement("table", null, createElement(TableHead$1, {
        column: column
      }), !loading && data.length > 0 && createElement(TableBody$1, {
        data: data,
        columnKeys: columnKeys
      })));
    }
  }]);

  return Table;
}(Component);

Table.defaultProps = {
  column: [],
  data: [],
  loading: false
};
polyfill(Table); //$FlowFixMe

var table = forwardRef(function (props, ref) {
  return createElement(Table, _extends$t({
    innerRef: ref
  }, props));
});
var css$7 = "/**\n * Breakpoint mixins\n **/\n.module_kudi-dip-side-bar__34FEI {\n  font-size: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background: #fff;\n  height: initial;\n  width: max-content; }\n  .module_kudi-dip-side-bar__34FEI > * {\n    box-sizing: inherit; }\n  @media (min-width: 768px) {\n    .module_kudi-dip-side-bar__34FEI {\n      height: 100vh; } }\n  .module_kudi-dip-side-bar-with-modal__3qQrv {\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    z-index: 999999999;\n    animation: module_showmodal__37U75 ease 0.3s;\n    background: rgba(89, 89, 89, 0.8); }\n  .module_kudi-dip-side-bar-drawer__KP73g {\n    background: #15328F;\n    width: max-content;\n    padding: 23px 20px 18px 20px; }\n    @media (min-width: 768px) {\n      .module_kudi-dip-side-bar-drawer__KP73g {\n        display: none; } }\n    .module_kudi-dip-side-bar-drawer__KP73g > svg {\n      height: 15px;\n      fill: #fff; }\n      .module_kudi-dip-side-bar-drawer__KP73g > svg path {\n        fill: #fff; }\n  .module_kudi-dip-side-bar-close__2E3sx {\n    position: absolute;\n    padding: 25px 11px;\n    top: 0;\n    right: 0;\n    display: none;\n    color: #fff;\n    text-align: center; }\n    .module_kudi-dip-side-bar-close__2E3sx > svg {\n      height: 20px;\n      margin-bottom: 20px;\n      fill: currentColor; }\n    .module_kudi-dip-side-bar-close__2E3sx > p {\n      margin: 0;\n      padding: 0;\n      font-size: 14px;\n      line-height: 17px; }\n  .module_kudi-dip-side-bar-with-modal__3qQrv > .module_kudi-dip-side-bar-close__2E3sx {\n    display: block; }\n  .module_kudi-dip-side-bar-menu__2RjTn {\n    position: absolute;\n    height: 100vh;\n    background: #18379A;\n    top: 0;\n    width: 80%; }\n    @media (min-width: 768px) {\n      .module_kudi-dip-side-bar-menu__2RjTn {\n        position: relative;\n        right: initial;\n        left: 0;\n        width: initial; } }\n    .module_kudi-dip-side-bar-menu__2RjTn > svg {\n      height: 30px;\n      margin: 23px 30px 60px 30px; }\n      @media (min-width: 768px) {\n        .module_kudi-dip-side-bar-menu__2RjTn > svg {\n          height: 25px;\n          margin: 21px 30px; } }\n    .module_kudi-dip-side-bar-menu-hide__3a5al {\n      left: -100vh; }\n      @media (min-width: 768px) {\n        .module_kudi-dip-side-bar-menu-hide__3a5al {\n          left: 0; } }\n    .module_kudi-dip-side-bar-menu-show__3AOsj {\n      animation: module_showmenu__1znkE ease 0.3s;\n      left: 0; }\n  .module_kudi-dip-side-bar-list__2CoyK {\n    padding: 40px 0;\n    background: inherit; }\n    @media (min-width: 768px) {\n      .module_kudi-dip-side-bar-list__2CoyK {\n        padding: 40px 15px; } }\n  .module_kudi-dip-side-bar-item__ra1wL, .module_kudi-dip-side-bar-logout-btn__2wvX0 {\n    background: inherit;\n    color: #8FAAFF;\n    font-size: 15px;\n    font-weight: normal;\n    line-height: 18px;\n    min-height: 45px;\n    padding-left: 30px;\n    width: 100%;\n    border-radius: 0;\n    margin-bottom: 5px;\n    text-transform: capitalize; }\n    @media (min-width: 768px) {\n      .module_kudi-dip-side-bar-item__ra1wL, .module_kudi-dip-side-bar-logout-btn__2wvX0 {\n        width: initial;\n        min-width: 220px;\n        padding-left: 15px;\n        margin-bottom: 10px;\n        border-radius: 5px; } }\n    .module_kudi-dip-side-bar-item__ra1wL:hover, .module_kudi-dip-side-bar-item-active__1Zyo_, .module_kudi-dip-side-bar-logout-btn__2wvX0:hover, .module_kudi-dip-side-bar-logout-btn-active__Gbuus {\n      background: #2443A7;\n      color: #fff;\n      font-weight: 500; }\n    .module_kudi-dip-side-bar-item__ra1wL > span:nth-of-type(1), .module_kudi-dip-side-bar-logout-btn__2wvX0 > span:nth-of-type(1) {\n      height: 20px; }\n      @media (min-width: 768px) {\n        .module_kudi-dip-side-bar-item__ra1wL > span:nth-of-type(1), .module_kudi-dip-side-bar-logout-btn__2wvX0 > span:nth-of-type(1) {\n          height: 18px; } }\n    .module_kudi-dip-side-bar-item__ra1wL > span:nth-of-type(2), .module_kudi-dip-side-bar-logout-btn__2wvX0 > span:nth-of-type(2) {\n      margin-left: 15px; }\n  .module_kudi-dip-side-bar-logout-btn__2wvX0 {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding-left: 30px;\n    border-top: 1px solid #2443A7;\n    margin-bottom: 0;\n    border-radius: 0;\n    background: #18379A;\n    height: 56px; }\n\n@keyframes module_showmodal__37U75 {\n  0% {\n    background: rgba(89, 89, 89, 0); }\n  100% {\n    background: rgba(89, 89, 89, 0.8); } }\n\n@keyframes module_showmenu__1znkE {\n  0% {\n    left: -100vh; }\n  100% {\n    left: 0vh; } }\n";
var styles$7 = {
  "kudi-dip-side-bar": "module_kudi-dip-side-bar__34FEI",
  "kudi-dip-side-bar-with-modal": "module_kudi-dip-side-bar-with-modal__3qQrv",
  "showmodal": "module_showmodal__37U75",
  "kudi-dip-side-bar-drawer": "module_kudi-dip-side-bar-drawer__KP73g",
  "kudi-dip-side-bar-close": "module_kudi-dip-side-bar-close__2E3sx",
  "kudi-dip-side-bar-menu": "module_kudi-dip-side-bar-menu__2RjTn",
  "kudi-dip-side-bar-menu-hide": "module_kudi-dip-side-bar-menu-hide__3a5al",
  "kudi-dip-side-bar-menu-show": "module_kudi-dip-side-bar-menu-show__3AOsj",
  "showmenu": "module_showmenu__1znkE",
  "kudi-dip-side-bar-list": "module_kudi-dip-side-bar-list__2CoyK",
  "kudi-dip-side-bar-item": "module_kudi-dip-side-bar-item__ra1wL",
  "kudi-dip-side-bar-logout-btn": "module_kudi-dip-side-bar-logout-btn__2wvX0",
  "kudi-dip-side-bar-item-active": "module_kudi-dip-side-bar-item-active__1Zyo_",
  "kudi-dip-side-bar-logout-btn-active": "module_kudi-dip-side-bar-logout-btn-active__Gbuus"
};
styleInject(css$7);

function _extends$u() {
  _extends$u = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$u.apply(this, arguments);
}

var _ref$j = /*#__PURE__*/React__default.createElement("path", {
  d: "M.622 2.104c.373-.375.903-.57 1.43-.57H5.35c-.539.563-1.102 1.103-1.648 1.66C2.468 4.423 1.237 5.657.004 6.888-.004 5.785.004 4.68 0 3.577a2 2 0 01.622-1.473zM11.386 1.536c1.764-.003 3.529 0 5.293-.002-2.26 2.275-4.533 4.536-6.796 6.807C6.587 11.633 3.298 14.933 0 18.223v-5.3c3.796-3.795 7.593-7.59 11.386-11.387zM.002 24.206C7.56 16.65 15.11 9.086 22.67 1.532c1.168.004 2.336.001 3.504.001.498-.001 1 .167 1.372.503.429.369.692.927.686 1.494v23.914c-.001.222.008.446-.023.667a2.042 2.042 0 01-.924 1.359c-.364.235-.806.318-1.233.307-1.167.002-2.335-.003-3.502.003-1.507-1.489-2.998-2.994-4.5-4.49-2.252-2.253-4.508-4.503-6.76-6.757-.306.27-.577.58-.87.865-.669.679-1.344 1.35-2.01 2.031 2.221 2.226 4.432 4.46 6.653 6.686.547.556 1.106 1.1 1.645 1.664-1.86-.004-3.72 0-5.579-.002-1.845-1.873-3.688-3.748-5.532-5.623-.945.972-1.886 1.95-2.834 2.918.488.478.984.947 1.468 1.429.439.423.882.841 1.308 1.277H2.096c-.53.007-1.07-.177-1.452-.55a2.006 2.006 0 01-.642-1.45v-3.572z",
  fill: "#00E59E"
});

var _ref2$b = /*#__PURE__*/React__default.createElement("path", {
  d: "M53.717 1.313h-7.06l-6.689 9.275V1.313h-6.074V29.59h6.074v-9.604l8.496 9.604h7.797L43.005 15.308 53.717 1.313zM68.662 20.56c0 2.669-1.478 3.9-3.447 3.9-1.683 0-3.407-1.067-3.407-3.817V10.424h-5.704v11.45c0 5.253 3.119 8.126 7.592 8.126 1.929 0 3.981-1.19 4.966-3.037v2.627h5.704V10.424h-5.704v10.137zM91.885 19.945c0 2.668-1.97 4.638-4.432 4.638-2.463 0-4.433-1.847-4.433-4.638 0-2.667 1.97-4.555 4.433-4.555 2.462 0 4.432 1.765 4.432 4.555zM97.672 0h-5.664v12.763c-.944-1.682-3.16-2.75-5.622-2.75-2.545 0-4.72.945-6.567 2.791-1.805 1.847-2.708 4.269-2.708 7.264 0 2.914.903 5.336 2.708 7.182 1.847 1.847 4.022 2.75 6.567 2.75 2.462 0 4.678-1.026 5.622-2.79v2.38h5.664V0zM100.444 10.424V29.59h5.664V10.424h-5.664zM103.276 0c-1.97 0-3.57 1.477-3.57 3.324 0 1.847 1.6 3.365 3.57 3.365 1.929 0 3.488-1.518 3.488-3.365 0-1.847-1.559-3.324-3.488-3.324z",
  fill: "#fff"
});

var SvgLogo$1 = function SvgLogo(props) {
  return React__default.createElement("svg", _extends$u({
    viewBox: "0 0 107 30",
    fill: "none"
  }, props), _ref$j, _ref2$b);
};

function _extends$v() {
  _extends$v = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$v.apply(this, arguments);
}

var _ref$k = /*#__PURE__*/React__default.createElement("path", {
  d: "M107.067 317.195c1.713-1.708 2.568-3.898 2.568-6.563 0-2.663-.855-4.853-2.568-6.571-1.714-1.707-3.905-2.562-6.567-2.562H9.135c-2.666 0-4.853.855-6.567 2.562C.859 305.772 0 307.962 0 310.632c0 2.665.855 4.855 2.568 6.563 1.714 1.711 3.905 2.566 6.567 2.566H100.5c2.666.005 4.853-.851 6.567-2.566zM310.629 109.634c2.669 0 4.859-.855 6.563-2.568 1.718-1.711 2.574-3.901 2.574-6.567V9.138c0-2.659-.856-4.85-2.574-6.565-1.704-1.711-3.895-2.57-6.563-2.57-2.662 0-4.853.859-6.563 2.57-1.711 1.713-2.566 3.903-2.566 6.565v91.361c0 2.666.855 4.856 2.566 6.567 1.718 1.713 3.908 2.568 6.563 2.568zM118.771 347.184c-2.478 0-4.664.855-6.567 2.563l-73.089 73.087c-1.713 1.902-2.568 4.093-2.568 6.567s.855 4.664 2.568 6.566c2.096 1.708 4.283 2.57 6.567 2.57 2.475 0 4.665-.862 6.567-2.57l73.089-73.087c1.714-1.902 2.568-4.093 2.568-6.57 0-2.471-.854-4.661-2.568-6.563-1.902-1.708-4.093-2.563-6.567-2.563zM356.315 127.905c2.283 0 4.473-.855 6.571-2.565l73.087-73.089c1.707-1.903 2.562-4.093 2.562-6.567 0-2.475-.855-4.665-2.562-6.567-1.91-1.709-4.093-2.568-6.571-2.568-2.471 0-4.66.859-6.563 2.568l-73.087 73.089c-1.708 1.903-2.57 4.093-2.57 6.567s.862 4.661 2.57 6.567c2.094 1.71 4.285 2.565 6.563 2.565zM350.607 193.005c-4-3.999-9.328-7.994-15.988-11.991l-5.14 68.238 78.23 78.508c5.328 5.328 7.987 11.807 7.987 19.417 0 7.423-2.662 13.802-7.987 19.13l-41.977 41.686c-5.146 5.146-11.608 7.666-19.417 7.566-7.81-.1-14.271-2.707-19.411-7.854l-77.946-78.225-68.234 5.144c3.999 6.656 7.993 11.988 11.991 15.985l95.362 95.643c15.803 16.18 35.207 24.27 58.238 24.27 22.846 0 42.154-7.898 57.957-23.695l41.977-41.685c16.173-15.8 24.27-35.115 24.27-57.958 0-22.46-7.994-41.877-23.982-58.248l-95.93-95.931zM472.518 157.889c-1.711-1.709-3.901-2.565-6.563-2.565H374.59c-2.662 0-4.853.855-6.563 2.565-1.715 1.713-2.57 3.903-2.57 6.567 0 2.666.855 4.856 2.57 6.567 1.711 1.712 3.901 2.568 6.563 2.568h91.365c2.662 0 4.853-.856 6.563-2.568 1.708-1.711 2.563-3.901 2.563-6.567.001-2.664-.855-4.854-2.563-6.567zM109.348 67.099c5.523-5.14 11.991-7.705 19.417-7.705 7.611 0 14.084 2.663 19.414 7.993l77.943 78.227 68.234-5.142c-4-6.661-7.99-11.991-11.991-15.987l-95.358-95.643c-15.798-16.178-35.212-24.27-58.242-24.27-22.841 0-42.16 7.902-57.958 23.7l-41.97 41.683C12.659 85.756 4.57 105.073 4.57 127.912c0 22.463 7.996 41.877 23.982 58.245l95.93 95.93c3.995 4.001 9.325 7.995 15.986 11.991l5.139-68.521-78.23-78.227c-5.327-5.33-7.992-11.801-7.992-19.417 0-7.421 2.662-13.796 7.992-19.126l41.971-41.688zM164.454 365.451c-2.667 0-4.854.855-6.567 2.563-1.711 1.711-2.568 3.901-2.568 6.57v91.358c0 2.669.854 4.853 2.568 6.57 1.713 1.707 3.9 2.566 6.567 2.566 2.666 0 4.853-.859 6.567-2.566 1.713-1.718 2.568-3.901 2.568-6.57v-91.358c0-2.662-.855-4.853-2.568-6.57-1.715-1.707-3.905-2.563-6.567-2.563z"
});

var SvgLink = function SvgLink(props) {
  return React__default.createElement("svg", _extends$v({
    viewBox: "0 0 475.082 475.082"
  }, props), _ref$k);
};

function _extends$w() {
  _extends$w = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$w.apply(this, arguments);
}

var _ref$l = /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0h20v2.143H0V0zm0 6.429h20V8.57H0V6.43zm20 6.428H0V15h20v-2.143z",
  fill: "#fff"
});

var SvgMenu = function SvgMenu(props) {
  return React__default.createElement("svg", _extends$w({
    viewBox: "0 0 20 15",
    fill: "none"
  }, props), _ref$l);
};

function _extends$x() {
  _extends$x = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$x.apply(this, arguments);
}

var _ref$m = /*#__PURE__*/React__default.createElement("path", {
  d: "M28.228 23.986L47.092 5.122a2.998 2.998 0 000-4.242 2.998 2.998 0 00-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 00-4.242 0 2.998 2.998 0 000 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 104.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 000-4.242L28.228 23.986z"
});

var SvgClose = function SvgClose(props) {
  return React__default.createElement("svg", _extends$x({
    viewBox: "0 0 47.971 47.971"
  }, props), _ref$m);
};

function _extends$y() {
  _extends$y = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$y.apply(this, arguments);
}

var _ref$n = /*#__PURE__*/React__default.createElement("path", {
  d: "M12.863 7.939c.51 0 .914-.4.914-.904V4.448l5.438-1.345v15.875l-5.438-1.345v-2.587a.902.902 0 00-.914-.904c-.51 0-.913.4-.913.904v3.28c0 .421.276.779.68.863l7.244 1.787a.96.96 0 00.786-.168.895.895 0 00.34-.715V1.904a.926.926 0 00-.34-.715.923.923 0 00-.552-.189c-.064 0-.15 0-.213.021l-7.244 1.787a.898.898 0 00-.68.862v3.28c-.021.59.382.989.892.989z",
  fill: "#8FA9FF",
  stroke: "#18379A",
  strokeWidth: 0.3
});

var _ref2$c = /*#__PURE__*/React__default.createElement("path", {
  d: "M1.27 11.66l3.782 3.744a.891.891 0 001.275 0 .87.87 0 000-1.262l-2.23-2.208H16.07c.51 0 .914-.4.914-.904a.902.902 0 00-.914-.904H4.075l2.252-2.229a.87.87 0 000-1.262.904.904 0 00-.637-.252.904.904 0 00-.638.252l-3.781 3.743c-.361.379-.361.946 0 1.283z",
  fill: "#8FA9FF",
  stroke: "#18379A",
  strokeWidth: 0.3
});

var SvgLogout = function SvgLogout(props) {
  return React__default.createElement("svg", _extends$y({
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _ref$n, _ref2$c);
};

function _extends$z() {
  _extends$z = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$z.apply(this, arguments);
}

function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SideBarItem = function SideBarItem(props) {
  var componentClassName = props.className,
      innerRef = props.innerRef,
      icon = props.icon,
      text = props.text,
      active = props.active,
      onClick = props.onClick;
  var componentClass = getClassPrefix('side-bar-item');
  var className = cx(styles$7["".concat(componentClass)], componentClassName, _defineProperty$6({}, "".concat(styles$7["".concat(componentClass, "-active")]), active));
  return createElement(Button$1, {
    onClick: onClick,
    ref: innerRef,
    className: className,
    icon: icon,
    variant: "flat"
  }, text);
};

SideBarItem.defaultProps = {
  icon: createElement(SvgLink, null),
  active: false,
  onClick: function onClick() {
    return null;
  } //$FlowFixMe

};
var sideBarItem = forwardRef(function (props, ref) {
  return createElement(SideBarItem, _extends$z({
    innerRef: ref
  }, props));
});

function _extends$A() {
  _extends$A = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$A.apply(this, arguments);
}

var SideBarList = function SideBarList(props) {
  var componentClassName = props.className,
      innerRef = props.innerRef,
      children = props.children;
  var componentClass = getClassPrefix('side-bar-list');
  var className = cx(styles$7["".concat(componentClass)], componentClassName);
  return createElement("div", {
    ref: innerRef,
    className: className
  }, children);
};

SideBarList.defaultProps = {}; //$FlowFixMe

var sideBarList = forwardRef(function (props, ref) {
  return createElement(SideBarList, _extends$A({
    innerRef: ref
  }, props));
});

function _extends$B() {
  _extends$B = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$B.apply(this, arguments);
}

function _typeof$9(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$9 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$9 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$9(obj);
}

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$9(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$9(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$9(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$9(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$9(self, call) {
  if (call && (_typeof$9(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$9(self);
}

function _assertThisInitialized$9(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf$9(o) {
  _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$9(o);
}

function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$9(subClass, superClass);
}

function _setPrototypeOf$9(o, p) {
  _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$9(o, p);
}

var SideBar = /*#__PURE__*/function (_React$Component) {
  _inherits$9(SideBar, _React$Component);

  function SideBar(props) {
    var _this;

    _classCallCheck$9(this, SideBar);

    _this = _possibleConstructorReturn$9(this, _getPrototypeOf$9(SideBar).call(this, props));

    _this._handleMenu = function () {
      return _this.setState(function (_ref) {
        var showMenu = _ref.showMenu;
        return {
          showMenu: !showMenu
        };
      });
    };

    _this.state = {
      showMenu: false
    };
    return _this;
  }

  _createClass$9(SideBar, [{
    key: "render",
    value: function render() {
      var _cx2;

      var _this$props = this.props,
          componentClassName = _this$props.className,
          innerRef = _this$props.innerRef,
          children = _this$props.children,
          logo = _this$props.logo,
          onLogout = _this$props.onLogout;
      var showMenu = this.state.showMenu;
      var componentClass = getClassPrefix('side-bar');
      var className = cx(styles$7["".concat(componentClass)], componentClassName, _defineProperty$7({}, "".concat(styles$7["".concat(componentClass, "-with-modal")]), showMenu));
      var menuClassName = cx(styles$7["".concat(componentClass, "-menu")], (_cx2 = {}, _defineProperty$7(_cx2, "".concat(styles$7["".concat(componentClass, "-menu-show")]), showMenu), _defineProperty$7(_cx2, "".concat(styles$7["".concat(componentClass, "-menu-hide")]), !showMenu), _cx2));
      return createElement("div", {
        ref: innerRef,
        className: className
      }, createElement("div", {
        onClick: this._handleMenu,
        className: styles$7["".concat(componentClass, "-drawer")]
      }, createElement(SvgMenu, null)), createElement("div", {
        className: menuClassName
      }, logo, children, createElement(Button$1, {
        className: styles$7["".concat(componentClass, "-logout-btn")],
        icon: createElement(SvgLogout, null),
        onClick: onLogout,
        variant: "flat"
      }, "Logout")), createElement("div", {
        onClick: this._handleMenu,
        className: styles$7["".concat(componentClass, "-close")]
      }, createElement(SvgClose, null), createElement("p", null, "Close")));
    }
  }]);

  return SideBar;
}(Component);

SideBar.defaultProps = {
  logo: createElement(SvgLogo$1, null),
  onLogout: function onLogout() {}
};
polyfill(SideBar); //$FlowFixMe

var sideBar = forwardRef(function (props, ref) {
  return createElement(SideBar, _extends$B({
    innerRef: ref
  }, props));
});
export { authLayout as AuthLayout, Button$1 as Button, ButtonGroup, DatePicker, DateRangePicker, input as Input, select as Select, sideBar as SideBar, sideBarItem as SideBarItem, sideBarList as SideBarList, table as Table, upload as Upload };